/**
 * Encore Foundation - 7.65.0
 *
 * The contents of this file is owned and generated by the Encore team.
 * If you need to make changes to the values stored here please reach out
 * to #encore on Slack.
 *
 * Links:
 *
 * - Source & Documentation: https://ghe.spotify.net/encore/foundation
 *
 * Tack!
 *
 * Encore
 * encore.spotify.net
 */
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * The Dark theme is used for our consumer products, like the Desktop client, Web Player, and the consumer mobile clients.
 */
export var darkTheme = {
    base: {
        background: {
            base: '#121212',
            highlight: '#1f1f1f',
            press: '#000000',
            elevated: { base: '#1f1f1f', highlight: '#2a2a2a', press: '#191919' },
            tinted: {
                base: 'rgba(255, 255, 255, 0.1)',
                highlight: 'rgba(255, 255, 255, 0.14)',
                press: 'rgba(255, 255, 255, 0.21)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#b3b3b3',
            brightAccent: '#1ed760',
            negative: '#f3727f',
            warning: '#ffa42b',
            positive: '#1ed760',
            announcement: '#4cb3ff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#7c7c7c',
            brightAccent: '#1ed760',
            negative: '#ed2c3f',
            warning: '#ffa42b',
            positive: '#1ed760',
            announcement: '#4cb3ff',
        },
        decorative: { base: '#ffffff', subdued: '#292929' },
    },
    brightAccent: {
        background: {
            base: '#1ed760',
            highlight: '#3be477',
            press: '#1abc54',
            elevated: { base: '#3be477', highlight: '#3be477', press: '#1abc54' },
            tinted: { base: '#1ed760', highlight: '#1ed760', press: '#1ed760' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#1abc54' },
    },
    negative: {
        background: {
            base: '#e91429',
            highlight: '#d81326',
            press: '#a60e1d',
            elevated: { base: '#d81326', highlight: '#d81326', press: '#a60e1d' },
            tinted: { base: '#e91429', highlight: '#e91429', press: '#e91429' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#ee3a4c' },
    },
    negativeSubdued: {
        background: {
            base: '#590810',
            highlight: '#6b0a13',
            press: '#9b0e1c',
            elevated: { base: '#6b0a13', highlight: '#6b0a13', press: '#9b0e1c' },
            tinted: { base: '#590810', highlight: '#590810', press: '#590810' },
        },
        text: {
            base: '#ffd2d7',
            subdued: '#ffd2d7',
            brightAccent: '#ffd2d7',
            negative: '#ffd2d7',
            warning: '#ffd2d7',
            positive: '#ffd2d7',
            announcement: '#ffd2d7',
        },
        essential: {
            base: '#ffd2d7',
            subdued: '#ffd2d7',
            brightAccent: '#ffd2d7',
            negative: '#ffd2d7',
            warning: '#ffd2d7',
            positive: '#ffd2d7',
            announcement: '#ffd2d7',
        },
        decorative: { base: '#ffd2d7', subdued: '#7b0b16' },
    },
    warning: {
        background: {
            base: '#ffa42b',
            highlight: '#ffb656',
            press: '#ee8800',
            elevated: { base: '#ffb656', highlight: '#ffb656', press: '#ee8800' },
            tinted: { base: '#ffa42b', highlight: '#ffa42b', press: '#ffa42b' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#f18900' },
    },
    warningSubdued: {
        background: {
            base: '#491e00',
            highlight: '#582400',
            press: '#833600',
            elevated: { base: '#582400', highlight: '#582400', press: '#833600' },
            tinted: { base: '#491e00', highlight: '#491e00', press: '#491e00' },
        },
        text: {
            base: '#ffd97e',
            subdued: '#ffd97e',
            brightAccent: '#ffd97e',
            negative: '#ffd97e',
            warning: '#ffd97e',
            positive: '#ffd97e',
            announcement: '#ffd97e',
        },
        essential: {
            base: '#ffd97e',
            subdued: '#ffd97e',
            brightAccent: '#ffd97e',
            negative: '#ffd97e',
            warning: '#ffd97e',
            positive: '#ffd97e',
            announcement: '#ffd97e',
        },
        decorative: { base: '#ffd97e', subdued: '#652a00' },
    },
    positive: {
        background: {
            base: '#1ed760',
            highlight: '#3be477',
            press: '#1abc54',
            elevated: { base: '#3be477', highlight: '#3be477', press: '#1abc54' },
            tinted: { base: '#1ed760', highlight: '#1ed760', press: '#1ed760' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#1abc54' },
    },
    positiveSubdued: {
        background: {
            base: '#073116',
            highlight: '#093c1b',
            press: '#0d5928',
            elevated: { base: '#093c1b', highlight: '#093c1b', press: '#0d5928' },
            tinted: { base: '#073116', highlight: '#073116', press: '#073116' },
        },
        text: {
            base: '#96f0b6',
            subdued: '#96f0b6',
            brightAccent: '#96f0b6',
            negative: '#96f0b6',
            warning: '#96f0b6',
            positive: '#96f0b6',
            announcement: '#96f0b6',
        },
        essential: {
            base: '#96f0b6',
            subdued: '#96f0b6',
            brightAccent: '#96f0b6',
            negative: '#96f0b6',
            warning: '#96f0b6',
            positive: '#96f0b6',
            announcement: '#96f0b6',
        },
        decorative: { base: '#96f0b6', subdued: '#0a4620' },
    },
    announcement: {
        background: {
            base: '#4cb3ff',
            highlight: '#69bfff',
            press: '#109aff',
            elevated: { base: '#69bfff', highlight: '#69bfff', press: '#109aff' },
            tinted: { base: '#4cb3ff', highlight: '#4cb3ff', press: '#4cb3ff' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#159cff' },
    },
    announcementSubdued: {
        background: {
            base: '#00285d',
            highlight: '#003171',
            press: '#0048a7',
            elevated: { base: '#003171', highlight: '#003171', press: '#0048a7' },
            tinted: { base: '#00285d', highlight: '#00285d', press: '#00285d' },
        },
        text: {
            base: '#c8e0fc',
            subdued: '#c8e0fc',
            brightAccent: '#c8e0fc',
            negative: '#c8e0fc',
            warning: '#c8e0fc',
            positive: '#c8e0fc',
            announcement: '#c8e0fc',
        },
        essential: {
            base: '#c8e0fc',
            subdued: '#c8e0fc',
            brightAccent: '#c8e0fc',
            negative: '#c8e0fc',
            warning: '#c8e0fc',
            positive: '#c8e0fc',
            announcement: '#c8e0fc',
        },
        decorative: { base: '#c8e0fc', subdued: '#003985' },
    },
    invertedDark: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#343434',
            elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
            tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
        },
        text: {
            base: '#ffffff',
            subdued: '#939393',
            brightAccent: '#1ed760',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#626262',
            brightAccent: '#1ed760',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    invertedLight: {
        background: {
            base: '#ffffff',
            highlight: '#f0f0f0',
            press: '#c7c7c7',
            elevated: { base: '#f0f0f0', highlight: '#f0f0f0', press: '#c7c7c7' },
            tinted: { base: '#ffffff', highlight: '#ffffff', press: '#ffffff' },
        },
        text: {
            base: '#000000',
            subdued: '#5a5a5a',
            brightAccent: '#127e38',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#8a8a8a',
            brightAccent: '#169f47',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    inverted: {
        background: {
            base: '#ffffff',
            highlight: '#f0f0f0',
            press: '#c7c7c7',
            elevated: { base: '#f0f0f0', highlight: '#f0f0f0', press: '#c7c7c7' },
            tinted: { base: '#ffffff', highlight: '#ffffff', press: '#ffffff' },
        },
        text: {
            base: '#000000',
            subdued: '#5a5a5a',
            brightAccent: '#127e38',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#8a8a8a',
            brightAccent: '#169f47',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    mutedAccent: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#2b2b2b',
            elevated: { base: '#141414', highlight: '#212121', press: '#0b0b0b' },
            tinted: {
                base: 'rgba(255, 255, 255, 0.13)',
                highlight: 'rgba(255, 255, 255, 0.17)',
                press: 'rgba(255, 255, 255, 0.24)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#a9a9a9',
            brightAccent: '#1ed760',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#747474',
            brightAccent: '#1ed760',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    overMedia: {
        background: {
            base: 'rgba(0, 0, 0, 0.54)',
            highlight: 'rgba(0, 0, 0, 0.58)',
            press: 'rgba(0, 0, 0, 0.68)',
            elevated: {
                base: 'rgba(0, 0, 0, 0.58)',
                highlight: 'rgba(0, 0, 0, 0.58)',
                press: 'rgba(0, 0, 0, 0.68)',
            },
            tinted: {
                base: 'rgba(0, 0, 0, 0.54)',
                highlight: 'rgba(0, 0, 0, 0.54)',
                press: 'rgba(0, 0, 0, 0.54)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: 'rgba(255, 255, 255, 0.13)' },
    },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * The Light theme is used for marketing contexts, like spotify.com, B2B products like Ad Studio, internal tools and generally when data density is high and text legibility is important.
 */
export var lightTheme = {
    base: {
        background: {
            base: '#ffffff',
            highlight: '#f5f5f5',
            press: '#e2e2e2',
            elevated: { base: '#ffffff', highlight: '#f5f5f5', press: '#e7e7e7' },
            tinted: {
                base: 'rgba(0, 0, 0, 0.08)',
                highlight: 'rgba(0, 0, 0, 0.12)',
                press: 'rgba(0, 0, 0, 0.19)',
            },
        },
        text: {
            base: '#000000',
            subdued: '#656565',
            brightAccent: '#107434',
            negative: '#c91123',
            warning: '#955500',
            positive: '#107434',
            announcement: '#0064c1',
        },
        essential: {
            base: '#000000',
            subdued: '#818181',
            brightAccent: '#159542',
            negative: '#e91429',
            warning: '#bf6d00',
            positive: '#159542',
            announcement: '#0074e0',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    brightAccent: {
        background: {
            base: '#1ed760',
            highlight: '#3be477',
            press: '#1abc54',
            elevated: { base: '#3be477', highlight: '#3be477', press: '#1abc54' },
            tinted: { base: '#1ed760', highlight: '#1ed760', press: '#1ed760' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#1abc54' },
    },
    negative: {
        background: {
            base: '#e91429',
            highlight: '#d81326',
            press: '#a60e1d',
            elevated: { base: '#d81326', highlight: '#d81326', press: '#a60e1d' },
            tinted: { base: '#e91429', highlight: '#e91429', press: '#e91429' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#ee3a4c' },
    },
    negativeSubdued: {
        background: {
            base: '#ffd2d7',
            highlight: '#ffe5e8',
            press: '#ffadb6',
            elevated: { base: '#ffe5e8', highlight: '#ffe5e8', press: '#ffadb6' },
            tinted: { base: '#ffd2d7', highlight: '#ffd2d7', press: '#ffd2d7' },
        },
        text: {
            base: '#590810',
            subdued: '#590810',
            brightAccent: '#590810',
            negative: '#590810',
            warning: '#590810',
            positive: '#590810',
            announcement: '#590810',
        },
        essential: {
            base: '#590810',
            subdued: '#590810',
            brightAccent: '#590810',
            negative: '#590810',
            warning: '#590810',
            positive: '#590810',
            announcement: '#590810',
        },
        decorative: { base: '#590810', subdued: '#ffb9c1' },
    },
    warning: {
        background: {
            base: '#ffa42b',
            highlight: '#ffb656',
            press: '#ee8800',
            elevated: { base: '#ffb656', highlight: '#ffb656', press: '#ee8800' },
            tinted: { base: '#ffa42b', highlight: '#ffa42b', press: '#ffa42b' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#f18900' },
    },
    warningSubdued: {
        background: {
            base: '#ffd97e',
            highlight: '#ffeab8',
            press: '#ffb504',
            elevated: { base: '#ffeab8', highlight: '#ffeab8', press: '#ffb504' },
            tinted: { base: '#ffd97e', highlight: '#ffd97e', press: '#ffd97e' },
        },
        text: {
            base: '#491e00',
            subdued: '#491e00',
            brightAccent: '#491e00',
            negative: '#491e00',
            warning: '#491e00',
            positive: '#491e00',
            announcement: '#491e00',
        },
        essential: {
            base: '#491e00',
            subdued: '#491e00',
            brightAccent: '#491e00',
            negative: '#491e00',
            warning: '#491e00',
            positive: '#491e00',
            announcement: '#491e00',
        },
        decorative: { base: '#491e00', subdued: '#ffc742' },
    },
    positive: {
        background: {
            base: '#1ed760',
            highlight: '#3be477',
            press: '#1abc54',
            elevated: { base: '#3be477', highlight: '#3be477', press: '#1abc54' },
            tinted: { base: '#1ed760', highlight: '#1ed760', press: '#1ed760' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#1abc54' },
    },
    positiveSubdued: {
        background: {
            base: '#96f0b6',
            highlight: '#c5f7d7',
            press: '#21df65',
            elevated: { base: '#c5f7d7', highlight: '#c5f7d7', press: '#21df65' },
            tinted: { base: '#96f0b6', highlight: '#96f0b6', press: '#96f0b6' },
        },
        text: {
            base: '#073116',
            subdued: '#073116',
            brightAccent: '#073116',
            negative: '#073116',
            warning: '#073116',
            positive: '#073116',
            announcement: '#073116',
        },
        essential: {
            base: '#073116',
            subdued: '#073116',
            brightAccent: '#073116',
            negative: '#073116',
            warning: '#073116',
            positive: '#073116',
            announcement: '#073116',
        },
        decorative: { base: '#073116', subdued: '#60e890' },
    },
    announcement: {
        background: {
            base: '#0074e0',
            highlight: '#006bcf',
            press: '#00529e',
            elevated: { base: '#006bcf', highlight: '#006bcf', press: '#00529e' },
            tinted: { base: '#0074e0', highlight: '#0074e0', press: '#0074e0' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#0386ff' },
    },
    announcementSubdued: {
        background: {
            base: '#b5e4ff',
            highlight: '#d5f0ff',
            press: '#75cdff',
            elevated: { base: '#d5f0ff', highlight: '#d5f0ff', press: '#75cdff' },
            tinted: { base: '#b5e4ff', highlight: '#b5e4ff', press: '#b5e4ff' },
        },
        text: {
            base: '#052a56',
            subdued: '#052a56',
            brightAccent: '#052a56',
            negative: '#052a56',
            warning: '#052a56',
            positive: '#052a56',
            announcement: '#052a56',
        },
        essential: {
            base: '#052a56',
            subdued: '#052a56',
            brightAccent: '#052a56',
            negative: '#052a56',
            warning: '#052a56',
            positive: '#052a56',
            announcement: '#052a56',
        },
        decorative: { base: '#052a56', subdued: '#85d3ff' },
    },
    invertedDark: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#343434',
            elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
            tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
        },
        text: {
            base: '#ffffff',
            subdued: '#939393',
            brightAccent: '#1ed760',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#626262',
            brightAccent: '#1ed760',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    invertedLight: {
        background: {
            base: '#ffffff',
            highlight: '#f0f0f0',
            press: '#c7c7c7',
            elevated: { base: '#f0f0f0', highlight: '#f0f0f0', press: '#c7c7c7' },
            tinted: { base: '#ffffff', highlight: '#ffffff', press: '#ffffff' },
        },
        text: {
            base: '#000000',
            subdued: '#5a5a5a',
            brightAccent: '#127e38',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#8a8a8a',
            brightAccent: '#169f47',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    inverted: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#343434',
            elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
            tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
        },
        text: {
            base: '#ffffff',
            subdued: '#939393',
            brightAccent: '#1ed760',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#626262',
            brightAccent: '#1ed760',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    mutedAccent: {
        background: {
            base: '#121212',
            highlight: '#1b1b1b',
            press: '#040404',
            elevated: { base: '#1b1b1b', highlight: '#232323', press: '#171717' },
            tinted: {
                base: 'rgba(255, 255, 255, 0.07)',
                highlight: 'rgba(255, 255, 255, 0.1)',
                press: 'rgba(255, 255, 255, 0.15)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#a7a7a7',
            brightAccent: '#1ed760',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#727272',
            brightAccent: '#1ed760',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#292929' },
    },
    overMedia: {
        background: {
            base: 'rgba(0, 0, 0, 0.54)',
            highlight: 'rgba(0, 0, 0, 0.58)',
            press: 'rgba(0, 0, 0, 0.68)',
            elevated: {
                base: 'rgba(0, 0, 0, 0.58)',
                highlight: 'rgba(0, 0, 0, 0.58)',
                press: 'rgba(0, 0, 0, 0.68)',
            },
            tinted: {
                base: 'rgba(0, 0, 0, 0.54)',
                highlight: 'rgba(0, 0, 0, 0.54)',
                press: 'rgba(0, 0, 0, 0.54)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: 'rgba(255, 255, 255, 0.13)' },
    },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * The Creator Dark theme is used for creator products, when building flows or illustrating views from the consumer app, like profile editing or canvas submission in S4A.
 */
export var creatorDarkTheme = {
    base: {
        background: {
            base: '#121212',
            highlight: '#1f1f1f',
            press: '#000000',
            elevated: { base: '#1f1f1f', highlight: '#2a2a2a', press: '#191919' },
            tinted: {
                base: 'rgba(255, 255, 255, 0.1)',
                highlight: 'rgba(255, 255, 255, 0.14)',
                press: 'rgba(255, 255, 255, 0.21)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#b3b3b3',
            brightAccent: '#a488ff',
            negative: '#f3727f',
            warning: '#ffa42b',
            positive: '#1ed760',
            announcement: '#4cb3ff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#7c7c7c',
            brightAccent: '#845eff',
            negative: '#ed2c3f',
            warning: '#ffa42b',
            positive: '#1ed760',
            announcement: '#4cb3ff',
        },
        decorative: { base: '#ffffff', subdued: '#292929' },
    },
    brightAccent: {
        background: {
            base: '#5925ff',
            highlight: '#450bff',
            press: '#2d00bd',
            elevated: { base: '#450bff', highlight: '#450bff', press: '#2d00bd' },
            tinted: { base: '#5925ff', highlight: '#5925ff', press: '#5925ff' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#7347ff' },
    },
    negative: {
        background: {
            base: '#e91429',
            highlight: '#d81326',
            press: '#a60e1d',
            elevated: { base: '#d81326', highlight: '#d81326', press: '#a60e1d' },
            tinted: { base: '#e91429', highlight: '#e91429', press: '#e91429' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#ee3a4c' },
    },
    negativeSubdued: {
        background: {
            base: '#590810',
            highlight: '#6b0a13',
            press: '#9b0e1c',
            elevated: { base: '#6b0a13', highlight: '#6b0a13', press: '#9b0e1c' },
            tinted: { base: '#590810', highlight: '#590810', press: '#590810' },
        },
        text: {
            base: '#ffd2d7',
            subdued: '#ffd2d7',
            brightAccent: '#ffd2d7',
            negative: '#ffd2d7',
            warning: '#ffd2d7',
            positive: '#ffd2d7',
            announcement: '#ffd2d7',
        },
        essential: {
            base: '#ffd2d7',
            subdued: '#ffd2d7',
            brightAccent: '#ffd2d7',
            negative: '#ffd2d7',
            warning: '#ffd2d7',
            positive: '#ffd2d7',
            announcement: '#ffd2d7',
        },
        decorative: { base: '#ffd2d7', subdued: '#7b0b16' },
    },
    warning: {
        background: {
            base: '#ffa42b',
            highlight: '#ffb656',
            press: '#ee8800',
            elevated: { base: '#ffb656', highlight: '#ffb656', press: '#ee8800' },
            tinted: { base: '#ffa42b', highlight: '#ffa42b', press: '#ffa42b' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#f18900' },
    },
    warningSubdued: {
        background: {
            base: '#491e00',
            highlight: '#582400',
            press: '#833600',
            elevated: { base: '#582400', highlight: '#582400', press: '#833600' },
            tinted: { base: '#491e00', highlight: '#491e00', press: '#491e00' },
        },
        text: {
            base: '#ffd97e',
            subdued: '#ffd97e',
            brightAccent: '#ffd97e',
            negative: '#ffd97e',
            warning: '#ffd97e',
            positive: '#ffd97e',
            announcement: '#ffd97e',
        },
        essential: {
            base: '#ffd97e',
            subdued: '#ffd97e',
            brightAccent: '#ffd97e',
            negative: '#ffd97e',
            warning: '#ffd97e',
            positive: '#ffd97e',
            announcement: '#ffd97e',
        },
        decorative: { base: '#ffd97e', subdued: '#652a00' },
    },
    positive: {
        background: {
            base: '#1ed760',
            highlight: '#3be477',
            press: '#1abc54',
            elevated: { base: '#3be477', highlight: '#3be477', press: '#1abc54' },
            tinted: { base: '#1ed760', highlight: '#1ed760', press: '#1ed760' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#1abc54' },
    },
    positiveSubdued: {
        background: {
            base: '#073116',
            highlight: '#093c1b',
            press: '#0d5928',
            elevated: { base: '#093c1b', highlight: '#093c1b', press: '#0d5928' },
            tinted: { base: '#073116', highlight: '#073116', press: '#073116' },
        },
        text: {
            base: '#96f0b6',
            subdued: '#96f0b6',
            brightAccent: '#96f0b6',
            negative: '#96f0b6',
            warning: '#96f0b6',
            positive: '#96f0b6',
            announcement: '#96f0b6',
        },
        essential: {
            base: '#96f0b6',
            subdued: '#96f0b6',
            brightAccent: '#96f0b6',
            negative: '#96f0b6',
            warning: '#96f0b6',
            positive: '#96f0b6',
            announcement: '#96f0b6',
        },
        decorative: { base: '#96f0b6', subdued: '#0a4620' },
    },
    announcement: {
        background: {
            base: '#4cb3ff',
            highlight: '#69bfff',
            press: '#109aff',
            elevated: { base: '#69bfff', highlight: '#69bfff', press: '#109aff' },
            tinted: { base: '#4cb3ff', highlight: '#4cb3ff', press: '#4cb3ff' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#159cff' },
    },
    announcementSubdued: {
        background: {
            base: '#00285d',
            highlight: '#003171',
            press: '#0048a7',
            elevated: { base: '#003171', highlight: '#003171', press: '#0048a7' },
            tinted: { base: '#00285d', highlight: '#00285d', press: '#00285d' },
        },
        text: {
            base: '#c8e0fc',
            subdued: '#c8e0fc',
            brightAccent: '#c8e0fc',
            negative: '#c8e0fc',
            warning: '#c8e0fc',
            positive: '#c8e0fc',
            announcement: '#c8e0fc',
        },
        essential: {
            base: '#c8e0fc',
            subdued: '#c8e0fc',
            brightAccent: '#c8e0fc',
            negative: '#c8e0fc',
            warning: '#c8e0fc',
            positive: '#c8e0fc',
            announcement: '#c8e0fc',
        },
        decorative: { base: '#c8e0fc', subdued: '#003985' },
    },
    invertedDark: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#343434',
            elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
            tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
        },
        text: {
            base: '#ffffff',
            subdued: '#939393',
            brightAccent: '#8660ff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#626262',
            brightAccent: '#6332ff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    invertedLight: {
        background: {
            base: '#ffffff',
            highlight: '#f0f0f0',
            press: '#c7c7c7',
            elevated: { base: '#f0f0f0', highlight: '#f0f0f0', press: '#c7c7c7' },
            tinted: { base: '#ffffff', highlight: '#ffffff', press: '#ffffff' },
        },
        text: {
            base: '#000000',
            subdued: '#5a5a5a',
            brightAccent: '#5925ff',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#8a8a8a',
            brightAccent: '#5925ff',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    inverted: {
        background: {
            base: '#ffffff',
            highlight: '#f0f0f0',
            press: '#c7c7c7',
            elevated: { base: '#f0f0f0', highlight: '#f0f0f0', press: '#c7c7c7' },
            tinted: { base: '#ffffff', highlight: '#ffffff', press: '#ffffff' },
        },
        text: {
            base: '#000000',
            subdued: '#5a5a5a',
            brightAccent: '#5925ff',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#8a8a8a',
            brightAccent: '#5925ff',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    mutedAccent: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#2b2b2b',
            elevated: { base: '#141414', highlight: '#212121', press: '#0b0b0b' },
            tinted: {
                base: 'rgba(255, 255, 255, 0.13)',
                highlight: 'rgba(255, 255, 255, 0.17)',
                press: 'rgba(255, 255, 255, 0.24)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#a9a9a9',
            brightAccent: '#9b7cff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#747474',
            brightAccent: '#7b51ff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    overMedia: {
        background: {
            base: 'rgba(0, 0, 0, 0.54)',
            highlight: 'rgba(0, 0, 0, 0.58)',
            press: 'rgba(0, 0, 0, 0.68)',
            elevated: {
                base: 'rgba(0, 0, 0, 0.58)',
                highlight: 'rgba(0, 0, 0, 0.58)',
                press: 'rgba(0, 0, 0, 0.68)',
            },
            tinted: {
                base: 'rgba(0, 0, 0, 0.54)',
                highlight: 'rgba(0, 0, 0, 0.54)',
                press: 'rgba(0, 0, 0, 0.54)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: 'rgba(255, 255, 255, 0.13)' },
    },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * The Creator Light theme is used for creator products, like Spotify for Artists, and Spotify for Publishers.
 */
export var creatorLightTheme = {
    base: {
        background: {
            base: '#ffffff',
            highlight: '#f5f5f5',
            press: '#e2e2e2',
            elevated: { base: '#ffffff', highlight: '#f5f5f5', press: '#e7e7e7' },
            tinted: {
                base: 'rgba(0, 0, 0, 0.08)',
                highlight: 'rgba(0, 0, 0, 0.12)',
                press: 'rgba(0, 0, 0, 0.19)',
            },
        },
        text: {
            base: '#000000',
            subdued: '#656565',
            brightAccent: '#4100f4',
            negative: '#c91123',
            warning: '#955500',
            positive: '#107434',
            announcement: '#0064c1',
        },
        essential: {
            base: '#000000',
            subdued: '#818181',
            brightAccent: '#4100f4',
            negative: '#e91429',
            warning: '#bf6d00',
            positive: '#159542',
            announcement: '#0074e0',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    brightAccent: {
        background: {
            base: '#4100f4',
            highlight: '#3b00dc',
            press: '#270091',
            elevated: { base: '#3b00dc', highlight: '#3b00dc', press: '#270091' },
            tinted: { base: '#4100f4', highlight: '#4100f4', press: '#4100f4' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#662fff' },
    },
    negative: {
        background: {
            base: '#e91429',
            highlight: '#d81326',
            press: '#a60e1d',
            elevated: { base: '#d81326', highlight: '#d81326', press: '#a60e1d' },
            tinted: { base: '#e91429', highlight: '#e91429', press: '#e91429' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#ee3a4c' },
    },
    negativeSubdued: {
        background: {
            base: '#ffd2d7',
            highlight: '#ffe5e8',
            press: '#ffadb6',
            elevated: { base: '#ffe5e8', highlight: '#ffe5e8', press: '#ffadb6' },
            tinted: { base: '#ffd2d7', highlight: '#ffd2d7', press: '#ffd2d7' },
        },
        text: {
            base: '#590810',
            subdued: '#590810',
            brightAccent: '#590810',
            negative: '#590810',
            warning: '#590810',
            positive: '#590810',
            announcement: '#590810',
        },
        essential: {
            base: '#590810',
            subdued: '#590810',
            brightAccent: '#590810',
            negative: '#590810',
            warning: '#590810',
            positive: '#590810',
            announcement: '#590810',
        },
        decorative: { base: '#590810', subdued: '#ffb9c1' },
    },
    warning: {
        background: {
            base: '#ffa42b',
            highlight: '#ffb656',
            press: '#ee8800',
            elevated: { base: '#ffb656', highlight: '#ffb656', press: '#ee8800' },
            tinted: { base: '#ffa42b', highlight: '#ffa42b', press: '#ffa42b' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#f18900' },
    },
    warningSubdued: {
        background: {
            base: '#ffd97e',
            highlight: '#ffeab8',
            press: '#ffb504',
            elevated: { base: '#ffeab8', highlight: '#ffeab8', press: '#ffb504' },
            tinted: { base: '#ffd97e', highlight: '#ffd97e', press: '#ffd97e' },
        },
        text: {
            base: '#491e00',
            subdued: '#491e00',
            brightAccent: '#491e00',
            negative: '#491e00',
            warning: '#491e00',
            positive: '#491e00',
            announcement: '#491e00',
        },
        essential: {
            base: '#491e00',
            subdued: '#491e00',
            brightAccent: '#491e00',
            negative: '#491e00',
            warning: '#491e00',
            positive: '#491e00',
            announcement: '#491e00',
        },
        decorative: { base: '#491e00', subdued: '#ffc742' },
    },
    positive: {
        background: {
            base: '#1ed760',
            highlight: '#3be477',
            press: '#1abc54',
            elevated: { base: '#3be477', highlight: '#3be477', press: '#1abc54' },
            tinted: { base: '#1ed760', highlight: '#1ed760', press: '#1ed760' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#1abc54' },
    },
    positiveSubdued: {
        background: {
            base: '#96f0b6',
            highlight: '#c5f7d7',
            press: '#21df65',
            elevated: { base: '#c5f7d7', highlight: '#c5f7d7', press: '#21df65' },
            tinted: { base: '#96f0b6', highlight: '#96f0b6', press: '#96f0b6' },
        },
        text: {
            base: '#073116',
            subdued: '#073116',
            brightAccent: '#073116',
            negative: '#073116',
            warning: '#073116',
            positive: '#073116',
            announcement: '#073116',
        },
        essential: {
            base: '#073116',
            subdued: '#073116',
            brightAccent: '#073116',
            negative: '#073116',
            warning: '#073116',
            positive: '#073116',
            announcement: '#073116',
        },
        decorative: { base: '#073116', subdued: '#60e890' },
    },
    announcement: {
        background: {
            base: '#0074e0',
            highlight: '#006bcf',
            press: '#00529e',
            elevated: { base: '#006bcf', highlight: '#006bcf', press: '#00529e' },
            tinted: { base: '#0074e0', highlight: '#0074e0', press: '#0074e0' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#0386ff' },
    },
    announcementSubdued: {
        background: {
            base: '#b5e4ff',
            highlight: '#d5f0ff',
            press: '#75cdff',
            elevated: { base: '#d5f0ff', highlight: '#d5f0ff', press: '#75cdff' },
            tinted: { base: '#b5e4ff', highlight: '#b5e4ff', press: '#b5e4ff' },
        },
        text: {
            base: '#052a56',
            subdued: '#052a56',
            brightAccent: '#052a56',
            negative: '#052a56',
            warning: '#052a56',
            positive: '#052a56',
            announcement: '#052a56',
        },
        essential: {
            base: '#052a56',
            subdued: '#052a56',
            brightAccent: '#052a56',
            negative: '#052a56',
            warning: '#052a56',
            positive: '#052a56',
            announcement: '#052a56',
        },
        decorative: { base: '#052a56', subdued: '#85d3ff' },
    },
    invertedDark: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#343434',
            elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
            tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
        },
        text: {
            base: '#ffffff',
            subdued: '#939393',
            brightAccent: '#8a5fff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#626262',
            brightAccent: '#6730ff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    invertedLight: {
        background: {
            base: '#ffffff',
            highlight: '#f0f0f0',
            press: '#c7c7c7',
            elevated: { base: '#f0f0f0', highlight: '#f0f0f0', press: '#c7c7c7' },
            tinted: { base: '#ffffff', highlight: '#ffffff', press: '#ffffff' },
        },
        text: {
            base: '#000000',
            subdued: '#5a5a5a',
            brightAccent: '#4100f4',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#8a8a8a',
            brightAccent: '#4100f4',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    inverted: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#343434',
            elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
            tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
        },
        text: {
            base: '#ffffff',
            subdued: '#939393',
            brightAccent: '#8a5fff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#626262',
            brightAccent: '#6730ff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    mutedAccent: {
        background: {
            base: '#121212',
            highlight: '#1b1b1b',
            press: '#040404',
            elevated: { base: '#1b1b1b', highlight: '#232323', press: '#171717' },
            tinted: {
                base: 'rgba(255, 255, 255, 0.07)',
                highlight: 'rgba(255, 255, 255, 0.1)',
                press: 'rgba(255, 255, 255, 0.15)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#a7a7a7',
            brightAccent: '#9c79ff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#727272',
            brightAccent: '#7d4dff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#292929' },
    },
    overMedia: {
        background: {
            base: 'rgba(0, 0, 0, 0.54)',
            highlight: 'rgba(0, 0, 0, 0.58)',
            press: 'rgba(0, 0, 0, 0.68)',
            elevated: {
                base: 'rgba(0, 0, 0, 0.58)',
                highlight: 'rgba(0, 0, 0, 0.58)',
                press: 'rgba(0, 0, 0, 0.68)',
            },
            tinted: {
                base: 'rgba(0, 0, 0, 0.54)',
                highlight: 'rgba(0, 0, 0, 0.54)',
                press: 'rgba(0, 0, 0, 0.54)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: 'rgba(255, 255, 255, 0.13)' },
    },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 * The Advertising Light theme is used for advertising products, like Ad Studio, Ad Studio Admin, and the ads.spotify.com marketing page.
 */
export var advertisingLightTheme = {
    base: {
        background: {
            base: '#ffffff',
            highlight: '#f5f5f5',
            press: '#e2e2e2',
            elevated: { base: '#ffffff', highlight: '#f5f5f5', press: '#e7e7e7' },
            tinted: {
                base: 'rgba(0, 0, 0, 0.08)',
                highlight: 'rgba(0, 0, 0, 0.12)',
                press: 'rgba(0, 0, 0, 0.19)',
            },
        },
        text: {
            base: '#121212',
            subdued: '#656565',
            brightAccent: '#2d6740',
            negative: '#c91123',
            warning: '#955500',
            positive: '#107434',
            announcement: '#0064c1',
        },
        essential: {
            base: '#121212',
            subdued: '#818181',
            brightAccent: '#2d6740',
            negative: '#e91429',
            warning: '#bf6d00',
            positive: '#159542',
            announcement: '#0074e0',
        },
        decorative: { base: '#121212', subdued: '#dedede' },
    },
    brightAccent: {
        background: {
            base: '#2d6740',
            highlight: '#295d3a',
            press: '#1d4129',
            elevated: { base: '#295d3a', highlight: '#295d3a', press: '#1d4129' },
            tinted: { base: '#2d6740', highlight: '#2d6740', press: '#2d6740' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#367b4c' },
    },
    negative: {
        background: {
            base: '#e91429',
            highlight: '#d81326',
            press: '#a60e1d',
            elevated: { base: '#d81326', highlight: '#d81326', press: '#a60e1d' },
            tinted: { base: '#e91429', highlight: '#e91429', press: '#e91429' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#ee3a4c' },
    },
    negativeSubdued: {
        background: {
            base: '#ffd2d7',
            highlight: '#ffe5e8',
            press: '#ffadb6',
            elevated: { base: '#ffe5e8', highlight: '#ffe5e8', press: '#ffadb6' },
            tinted: { base: '#ffd2d7', highlight: '#ffd2d7', press: '#ffd2d7' },
        },
        text: {
            base: '#590810',
            subdued: '#590810',
            brightAccent: '#590810',
            negative: '#590810',
            warning: '#590810',
            positive: '#590810',
            announcement: '#590810',
        },
        essential: {
            base: '#590810',
            subdued: '#590810',
            brightAccent: '#590810',
            negative: '#590810',
            warning: '#590810',
            positive: '#590810',
            announcement: '#590810',
        },
        decorative: { base: '#590810', subdued: '#ffb9c1' },
    },
    warning: {
        background: {
            base: '#ffa42b',
            highlight: '#ffb656',
            press: '#ee8800',
            elevated: { base: '#ffb656', highlight: '#ffb656', press: '#ee8800' },
            tinted: { base: '#ffa42b', highlight: '#ffa42b', press: '#ffa42b' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#f18900' },
    },
    warningSubdued: {
        background: {
            base: '#ffd97e',
            highlight: '#ffeab8',
            press: '#ffb504',
            elevated: { base: '#ffeab8', highlight: '#ffeab8', press: '#ffb504' },
            tinted: { base: '#ffd97e', highlight: '#ffd97e', press: '#ffd97e' },
        },
        text: {
            base: '#491e00',
            subdued: '#491e00',
            brightAccent: '#491e00',
            negative: '#491e00',
            warning: '#491e00',
            positive: '#491e00',
            announcement: '#491e00',
        },
        essential: {
            base: '#491e00',
            subdued: '#491e00',
            brightAccent: '#491e00',
            negative: '#491e00',
            warning: '#491e00',
            positive: '#491e00',
            announcement: '#491e00',
        },
        decorative: { base: '#491e00', subdued: '#ffc742' },
    },
    positive: {
        background: {
            base: '#1ed760',
            highlight: '#3be477',
            press: '#1abc54',
            elevated: { base: '#3be477', highlight: '#3be477', press: '#1abc54' },
            tinted: { base: '#1ed760', highlight: '#1ed760', press: '#1ed760' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#1abc54' },
    },
    positiveSubdued: {
        background: {
            base: '#96f0b6',
            highlight: '#c5f7d7',
            press: '#21df65',
            elevated: { base: '#c5f7d7', highlight: '#c5f7d7', press: '#21df65' },
            tinted: { base: '#96f0b6', highlight: '#96f0b6', press: '#96f0b6' },
        },
        text: {
            base: '#073116',
            subdued: '#073116',
            brightAccent: '#073116',
            negative: '#073116',
            warning: '#073116',
            positive: '#073116',
            announcement: '#073116',
        },
        essential: {
            base: '#073116',
            subdued: '#073116',
            brightAccent: '#073116',
            negative: '#073116',
            warning: '#073116',
            positive: '#073116',
            announcement: '#073116',
        },
        decorative: { base: '#073116', subdued: '#60e890' },
    },
    announcement: {
        background: {
            base: '#0074e0',
            highlight: '#006bcf',
            press: '#00529e',
            elevated: { base: '#006bcf', highlight: '#006bcf', press: '#00529e' },
            tinted: { base: '#0074e0', highlight: '#0074e0', press: '#0074e0' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#0386ff' },
    },
    announcementSubdued: {
        background: {
            base: '#b5e4ff',
            highlight: '#d5f0ff',
            press: '#75cdff',
            elevated: { base: '#d5f0ff', highlight: '#d5f0ff', press: '#75cdff' },
            tinted: { base: '#b5e4ff', highlight: '#b5e4ff', press: '#b5e4ff' },
        },
        text: {
            base: '#052a56',
            subdued: '#052a56',
            brightAccent: '#052a56',
            negative: '#052a56',
            warning: '#052a56',
            positive: '#052a56',
            announcement: '#052a56',
        },
        essential: {
            base: '#052a56',
            subdued: '#052a56',
            brightAccent: '#052a56',
            negative: '#052a56',
            warning: '#052a56',
            positive: '#052a56',
            announcement: '#052a56',
        },
        decorative: { base: '#052a56', subdued: '#85d3ff' },
    },
    invertedDark: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#343434',
            elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
            tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
        },
        text: {
            base: '#ffffff',
            subdued: '#939393',
            brightAccent: '#3e8d58',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#626262',
            brightAccent: '#306e44',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    invertedLight: {
        background: {
            base: '#ffffff',
            highlight: '#f0f0f0',
            press: '#c7c7c7',
            elevated: { base: '#f0f0f0', highlight: '#f0f0f0', press: '#c7c7c7' },
            tinted: { base: '#ffffff', highlight: '#ffffff', press: '#ffffff' },
        },
        text: {
            base: '#000000',
            subdued: '#5a5a5a',
            brightAccent: '#2d6740',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#8a8a8a',
            brightAccent: '#2d6740',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    inverted: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#343434',
            elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
            tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
        },
        text: {
            base: '#ffffff',
            subdued: '#939393',
            brightAccent: '#3e8d58',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#626262',
            brightAccent: '#306e44',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    mutedAccent: {
        background: {
            base: '#f7f5f2',
            highlight: '#efebe5',
            press: '#bfbfbf',
            elevated: { base: '#ebe9e6', highlight: '#efebe5', press: '#bfbfbf' },
            tinted: {
                base: 'rgba(0, 0, 0, 0.08)',
                highlight: 'rgba(0, 0, 0, 0.12)',
                press: 'rgba(0, 0, 0, 0.2)',
            },
        },
        text: {
            base: '#000000',
            subdued: '#5c5c5c',
            brightAccent: '#2d6740',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#858585',
            brightAccent: '#2d6740',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    overMedia: {
        background: {
            base: 'rgba(0, 0, 0, 0.54)',
            highlight: 'rgba(0, 0, 0, 0.58)',
            press: 'rgba(0, 0, 0, 0.68)',
            elevated: {
                base: 'rgba(0, 0, 0, 0.58)',
                highlight: 'rgba(0, 0, 0, 0.58)',
                press: 'rgba(0, 0, 0, 0.68)',
            },
            tinted: {
                base: 'rgba(0, 0, 0, 0.54)',
                highlight: 'rgba(0, 0, 0, 0.54)',
                press: 'rgba(0, 0, 0, 0.54)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: 'rgba(255, 255, 255, 0.13)' },
    },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 * The Advertising Dark theme is used for advertising products, like Ad Studio, Ad Studio Admin, and the ads.spotify.com marketing page.
 */
export var advertisingDarkTheme = {
    base: {
        background: {
            base: '#14201d',
            highlight: '#1b2c28',
            press: '#0a110f',
            elevated: { base: '#1b2c28', highlight: '#223631', press: '#182623' },
            tinted: {
                base: 'rgba(255, 255, 255, 0.08)',
                highlight: 'rgba(255, 255, 255, 0.12)',
                press: 'rgba(255, 255, 255, 0.19)',
            },
        },
        text: {
            base: '#edf2ef',
            subdued: '#a1c5bc',
            brightAccent: '#1ed760',
            negative: '#f4818d',
            warning: '#ffa42b',
            positive: '#1ed760',
            announcement: '#64a7f6',
        },
        essential: {
            base: '#edf2ef',
            subdued: '#598e81',
            brightAccent: '#1ed760',
            negative: '#ef4354',
            warning: '#ffa42b',
            positive: '#1ed760',
            announcement: '#2483f3',
        },
        decorative: { base: '#edf2ef', subdued: '#213530' },
    },
    brightAccent: {
        background: {
            base: '#1ed760',
            highlight: '#3be477',
            press: '#1abc54',
            elevated: { base: '#3be477', highlight: '#3be477', press: '#1abc54' },
            tinted: { base: '#1ed760', highlight: '#1ed760', press: '#1ed760' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#1abc54' },
    },
    negative: {
        background: {
            base: '#e91429',
            highlight: '#d81326',
            press: '#a60e1d',
            elevated: { base: '#d81326', highlight: '#d81326', press: '#a60e1d' },
            tinted: { base: '#e91429', highlight: '#e91429', press: '#e91429' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#ee3a4c' },
    },
    negativeSubdued: {
        background: {
            base: '#590810',
            highlight: '#6b0a13',
            press: '#9b0e1c',
            elevated: { base: '#6b0a13', highlight: '#6b0a13', press: '#9b0e1c' },
            tinted: { base: '#590810', highlight: '#590810', press: '#590810' },
        },
        text: {
            base: '#ffd2d7',
            subdued: '#ffd2d7',
            brightAccent: '#ffd2d7',
            negative: '#ffd2d7',
            warning: '#ffd2d7',
            positive: '#ffd2d7',
            announcement: '#ffd2d7',
        },
        essential: {
            base: '#ffd2d7',
            subdued: '#ffd2d7',
            brightAccent: '#ffd2d7',
            negative: '#ffd2d7',
            warning: '#ffd2d7',
            positive: '#ffd2d7',
            announcement: '#ffd2d7',
        },
        decorative: { base: '#ffd2d7', subdued: '#7b0b16' },
    },
    warning: {
        background: {
            base: '#ffa42b',
            highlight: '#ffb656',
            press: '#ee8800',
            elevated: { base: '#ffb656', highlight: '#ffb656', press: '#ee8800' },
            tinted: { base: '#ffa42b', highlight: '#ffa42b', press: '#ffa42b' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#f18900' },
    },
    warningSubdued: {
        background: {
            base: '#491e00',
            highlight: '#582400',
            press: '#833600',
            elevated: { base: '#582400', highlight: '#582400', press: '#833600' },
            tinted: { base: '#491e00', highlight: '#491e00', press: '#491e00' },
        },
        text: {
            base: '#ffd97e',
            subdued: '#ffd97e',
            brightAccent: '#ffd97e',
            negative: '#ffd97e',
            warning: '#ffd97e',
            positive: '#ffd97e',
            announcement: '#ffd97e',
        },
        essential: {
            base: '#ffd97e',
            subdued: '#ffd97e',
            brightAccent: '#ffd97e',
            negative: '#ffd97e',
            warning: '#ffd97e',
            positive: '#ffd97e',
            announcement: '#ffd97e',
        },
        decorative: { base: '#ffd97e', subdued: '#652a00' },
    },
    positive: {
        background: {
            base: '#1ed760',
            highlight: '#3be477',
            press: '#1abc54',
            elevated: { base: '#3be477', highlight: '#3be477', press: '#1abc54' },
            tinted: { base: '#1ed760', highlight: '#1ed760', press: '#1ed760' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#1abc54' },
    },
    positiveSubdued: {
        background: {
            base: '#073116',
            highlight: '#093c1b',
            press: '#0d5928',
            elevated: { base: '#093c1b', highlight: '#093c1b', press: '#0d5928' },
            tinted: { base: '#073116', highlight: '#073116', press: '#073116' },
        },
        text: {
            base: '#96f0b6',
            subdued: '#96f0b6',
            brightAccent: '#96f0b6',
            negative: '#96f0b6',
            warning: '#96f0b6',
            positive: '#96f0b6',
            announcement: '#96f0b6',
        },
        essential: {
            base: '#96f0b6',
            subdued: '#96f0b6',
            brightAccent: '#96f0b6',
            negative: '#96f0b6',
            warning: '#96f0b6',
            positive: '#96f0b6',
            announcement: '#96f0b6',
        },
        decorative: { base: '#96f0b6', subdued: '#0a4620' },
    },
    announcement: {
        background: {
            base: '#0d72ea',
            highlight: '#1b7df2',
            press: '#0b61c7',
            elevated: { base: '#1b7df2', highlight: '#1b7df2', press: '#0b61c7' },
            tinted: { base: '#0d72ea', highlight: '#0d72ea', press: '#0d72ea' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#0b61c8' },
    },
    announcementSubdued: {
        background: {
            base: '#00285d',
            highlight: '#003171',
            press: '#0048a7',
            elevated: { base: '#003171', highlight: '#003171', press: '#0048a7' },
            tinted: { base: '#00285d', highlight: '#00285d', press: '#00285d' },
        },
        text: {
            base: '#c8e0fc',
            subdued: '#c8e0fc',
            brightAccent: '#c8e0fc',
            negative: '#c8e0fc',
            warning: '#c8e0fc',
            positive: '#c8e0fc',
            announcement: '#c8e0fc',
        },
        essential: {
            base: '#c8e0fc',
            subdued: '#c8e0fc',
            brightAccent: '#c8e0fc',
            negative: '#c8e0fc',
            warning: '#c8e0fc',
            positive: '#c8e0fc',
            announcement: '#c8e0fc',
        },
        decorative: { base: '#c8e0fc', subdued: '#003985' },
    },
    invertedDark: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#343434',
            elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
            tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
        },
        text: {
            base: '#ffffff',
            subdued: '#939393',
            brightAccent: '#1ed760',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#626262',
            brightAccent: '#1ed760',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    invertedLight: {
        background: {
            base: '#ffffff',
            highlight: '#f0f0f0',
            press: '#c7c7c7',
            elevated: { base: '#f0f0f0', highlight: '#f0f0f0', press: '#c7c7c7' },
            tinted: { base: '#ffffff', highlight: '#ffffff', press: '#ffffff' },
        },
        text: {
            base: '#000000',
            subdued: '#5a5a5a',
            brightAccent: '#127e38',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#8a8a8a',
            brightAccent: '#169f47',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    inverted: {
        background: {
            base: '#ffffff',
            highlight: '#f0f0f0',
            press: '#c7c7c7',
            elevated: { base: '#f0f0f0', highlight: '#f0f0f0', press: '#c7c7c7' },
            tinted: { base: '#ffffff', highlight: '#ffffff', press: '#ffffff' },
        },
        text: {
            base: '#000000',
            subdued: '#5a5a5a',
            brightAccent: '#127e38',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#8a8a8a',
            brightAccent: '#169f47',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    mutedAccent: {
        background: {
            base: '#08110e',
            highlight: '#172522',
            press: '#020303',
            elevated: { base: '#141b1a', highlight: '#1e302c', press: '#131f1c' },
            tinted: {
                base: 'rgba(255, 255, 255, 0.09)',
                highlight: 'rgba(255, 255, 255, 0.12)',
                press: 'rgba(255, 255, 255, 0.19)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#9cada9',
            brightAccent: '#1ed760',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#55887b',
            brightAccent: '#1ed760',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#183029' },
    },
    overMedia: {
        background: {
            base: 'rgba(0, 0, 0, 0.54)',
            highlight: 'rgba(0, 0, 0, 0.58)',
            press: 'rgba(0, 0, 0, 0.68)',
            elevated: {
                base: 'rgba(0, 0, 0, 0.58)',
                highlight: 'rgba(0, 0, 0, 0.58)',
                press: 'rgba(0, 0, 0, 0.68)',
            },
            tinted: {
                base: 'rgba(0, 0, 0, 0.54)',
                highlight: 'rgba(0, 0, 0, 0.54)',
                press: 'rgba(0, 0, 0, 0.54)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: 'rgba(255, 255, 255, 0.13)' },
    },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * The Quicksilver Light theme is used for Quicksilver, an internal Spotify product.
 */
export var quicksilverLightTheme = {
    base: {
        background: {
            base: '#ffffff',
            highlight: '#f5f5f5',
            press: '#e2e2e2',
            elevated: { base: '#ffffff', highlight: '#f5f5f5', press: '#e7e7e7' },
            tinted: {
                base: 'rgba(0, 0, 0, 0.08)',
                highlight: 'rgba(0, 0, 0, 0.12)',
                press: 'rgba(0, 0, 0, 0.19)',
            },
        },
        text: {
            base: '#000000',
            subdued: '#656565',
            brightAccent: '#543edd',
            negative: '#c91123',
            warning: '#955500',
            positive: '#107434',
            announcement: '#0064c1',
        },
        essential: {
            base: '#000000',
            subdued: '#818181',
            brightAccent: '#543edd',
            negative: '#e91429',
            warning: '#bf6d00',
            positive: '#159542',
            announcement: '#0074e0',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    brightAccent: {
        background: {
            base: '#543edd',
            highlight: '#4830db',
            press: '#301da4',
            elevated: { base: '#4830db', highlight: '#4830db', press: '#301da4' },
            tinted: { base: '#543edd', highlight: '#543edd', press: '#543edd' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#6a57e1' },
    },
    negative: {
        background: {
            base: '#e91429',
            highlight: '#d81326',
            press: '#a60e1d',
            elevated: { base: '#d81326', highlight: '#d81326', press: '#a60e1d' },
            tinted: { base: '#e91429', highlight: '#e91429', press: '#e91429' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#ee3a4c' },
    },
    negativeSubdued: {
        background: {
            base: '#ffd2d7',
            highlight: '#ffe5e8',
            press: '#ffadb6',
            elevated: { base: '#ffe5e8', highlight: '#ffe5e8', press: '#ffadb6' },
            tinted: { base: '#ffd2d7', highlight: '#ffd2d7', press: '#ffd2d7' },
        },
        text: {
            base: '#590810',
            subdued: '#590810',
            brightAccent: '#590810',
            negative: '#590810',
            warning: '#590810',
            positive: '#590810',
            announcement: '#590810',
        },
        essential: {
            base: '#590810',
            subdued: '#590810',
            brightAccent: '#590810',
            negative: '#590810',
            warning: '#590810',
            positive: '#590810',
            announcement: '#590810',
        },
        decorative: { base: '#590810', subdued: '#ffb9c1' },
    },
    warning: {
        background: {
            base: '#ffa42b',
            highlight: '#ffb656',
            press: '#ee8800',
            elevated: { base: '#ffb656', highlight: '#ffb656', press: '#ee8800' },
            tinted: { base: '#ffa42b', highlight: '#ffa42b', press: '#ffa42b' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#f18900' },
    },
    warningSubdued: {
        background: {
            base: '#ffd97e',
            highlight: '#ffeab8',
            press: '#ffb504',
            elevated: { base: '#ffeab8', highlight: '#ffeab8', press: '#ffb504' },
            tinted: { base: '#ffd97e', highlight: '#ffd97e', press: '#ffd97e' },
        },
        text: {
            base: '#491e00',
            subdued: '#491e00',
            brightAccent: '#491e00',
            negative: '#491e00',
            warning: '#491e00',
            positive: '#491e00',
            announcement: '#491e00',
        },
        essential: {
            base: '#491e00',
            subdued: '#491e00',
            brightAccent: '#491e00',
            negative: '#491e00',
            warning: '#491e00',
            positive: '#491e00',
            announcement: '#491e00',
        },
        decorative: { base: '#491e00', subdued: '#ffc742' },
    },
    positive: {
        background: {
            base: '#1ed760',
            highlight: '#3be477',
            press: '#1abc54',
            elevated: { base: '#3be477', highlight: '#3be477', press: '#1abc54' },
            tinted: { base: '#1ed760', highlight: '#1ed760', press: '#1ed760' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#1abc54' },
    },
    positiveSubdued: {
        background: {
            base: '#96f0b6',
            highlight: '#c5f7d7',
            press: '#21df65',
            elevated: { base: '#c5f7d7', highlight: '#c5f7d7', press: '#21df65' },
            tinted: { base: '#96f0b6', highlight: '#96f0b6', press: '#96f0b6' },
        },
        text: {
            base: '#073116',
            subdued: '#073116',
            brightAccent: '#073116',
            negative: '#073116',
            warning: '#073116',
            positive: '#073116',
            announcement: '#073116',
        },
        essential: {
            base: '#073116',
            subdued: '#073116',
            brightAccent: '#073116',
            negative: '#073116',
            warning: '#073116',
            positive: '#073116',
            announcement: '#073116',
        },
        decorative: { base: '#073116', subdued: '#60e890' },
    },
    announcement: {
        background: {
            base: '#0074e0',
            highlight: '#006bcf',
            press: '#00529e',
            elevated: { base: '#006bcf', highlight: '#006bcf', press: '#00529e' },
            tinted: { base: '#0074e0', highlight: '#0074e0', press: '#0074e0' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#0386ff' },
    },
    announcementSubdued: {
        background: {
            base: '#b5e4ff',
            highlight: '#d5f0ff',
            press: '#75cdff',
            elevated: { base: '#d5f0ff', highlight: '#d5f0ff', press: '#75cdff' },
            tinted: { base: '#b5e4ff', highlight: '#b5e4ff', press: '#b5e4ff' },
        },
        text: {
            base: '#052a56',
            subdued: '#052a56',
            brightAccent: '#052a56',
            negative: '#052a56',
            warning: '#052a56',
            positive: '#052a56',
            announcement: '#052a56',
        },
        essential: {
            base: '#052a56',
            subdued: '#052a56',
            brightAccent: '#052a56',
            negative: '#052a56',
            warning: '#052a56',
            positive: '#052a56',
            announcement: '#052a56',
        },
        decorative: { base: '#052a56', subdued: '#85d3ff' },
    },
    invertedDark: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#343434',
            elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
            tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
        },
        text: {
            base: '#ffffff',
            subdued: '#939393',
            brightAccent: '#7d6ce5',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#626262',
            brightAccent: '#5c48df',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    invertedLight: {
        background: {
            base: '#ffffff',
            highlight: '#f0f0f0',
            press: '#c7c7c7',
            elevated: { base: '#f0f0f0', highlight: '#f0f0f0', press: '#c7c7c7' },
            tinted: { base: '#ffffff', highlight: '#ffffff', press: '#ffffff' },
        },
        text: {
            base: '#000000',
            subdued: '#5a5a5a',
            brightAccent: '#543edd',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#8a8a8a',
            brightAccent: '#543edd',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    inverted: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#343434',
            elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
            tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
        },
        text: {
            base: '#ffffff',
            subdued: '#939393',
            brightAccent: '#7d6ce5',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#626262',
            brightAccent: '#5c48df',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    mutedAccent: {
        background: {
            base: '#121212',
            highlight: '#1b1b1b',
            press: '#040404',
            elevated: { base: '#1b1b1b', highlight: '#232323', press: '#171717' },
            tinted: {
                base: 'rgba(255, 255, 255, 0.07)',
                highlight: 'rgba(255, 255, 255, 0.1)',
                press: 'rgba(255, 255, 255, 0.15)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#a7a7a7',
            brightAccent: '#9082e9',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#727272',
            brightAccent: '#705ee3',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#292929' },
    },
    overMedia: {
        background: {
            base: 'rgba(0, 0, 0, 0.54)',
            highlight: 'rgba(0, 0, 0, 0.58)',
            press: 'rgba(0, 0, 0, 0.68)',
            elevated: {
                base: 'rgba(0, 0, 0, 0.58)',
                highlight: 'rgba(0, 0, 0, 0.58)',
                press: 'rgba(0, 0, 0, 0.68)',
            },
            tinted: {
                base: 'rgba(0, 0, 0, 0.54)',
                highlight: 'rgba(0, 0, 0, 0.54)',
                press: 'rgba(0, 0, 0, 0.54)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: 'rgba(255, 255, 255, 0.13)' },
    },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * The S4C Light theme is used for Spotify Creator Studio, a product used to create, distribute, and monetize podcasts.
 */
export var s4cLightTheme = {
    base: {
        background: {
            base: '#ffffff',
            highlight: '#f5f5f5',
            press: '#e2e2e2',
            elevated: { base: '#ffffff', highlight: '#f5f5f5', press: '#e7e7e7' },
            tinted: {
                base: 'rgba(0, 0, 0, 0.08)',
                highlight: 'rgba(0, 0, 0, 0.12)',
                press: 'rgba(0, 0, 0, 0.19)',
            },
        },
        text: {
            base: '#000000',
            subdued: '#656565',
            brightAccent: '#4d44ff',
            negative: '#c91123',
            warning: '#955500',
            positive: '#107434',
            announcement: '#0064c1',
        },
        essential: {
            base: '#000000',
            subdued: '#818181',
            brightAccent: '#746dff',
            negative: '#e91429',
            warning: '#bf6d00',
            positive: '#159542',
            announcement: '#0074e0',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    brightAccent: {
        background: {
            base: '#9691ff',
            highlight: '#a39eff',
            press: '#7e77ff',
            elevated: { base: '#a39eff', highlight: '#a39eff', press: '#7e77ff' },
            tinted: { base: '#9691ff', highlight: '#9691ff', press: '#9691ff' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#807aff' },
    },
    negative: {
        background: {
            base: '#e91429',
            highlight: '#d81326',
            press: '#a60e1d',
            elevated: { base: '#d81326', highlight: '#d81326', press: '#a60e1d' },
            tinted: { base: '#e91429', highlight: '#e91429', press: '#e91429' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#ee3a4c' },
    },
    negativeSubdued: {
        background: {
            base: '#ffd2d7',
            highlight: '#ffe5e8',
            press: '#ffadb6',
            elevated: { base: '#ffe5e8', highlight: '#ffe5e8', press: '#ffadb6' },
            tinted: { base: '#ffd2d7', highlight: '#ffd2d7', press: '#ffd2d7' },
        },
        text: {
            base: '#590810',
            subdued: '#590810',
            brightAccent: '#590810',
            negative: '#590810',
            warning: '#590810',
            positive: '#590810',
            announcement: '#590810',
        },
        essential: {
            base: '#590810',
            subdued: '#590810',
            brightAccent: '#590810',
            negative: '#590810',
            warning: '#590810',
            positive: '#590810',
            announcement: '#590810',
        },
        decorative: { base: '#590810', subdued: '#ffb9c1' },
    },
    warning: {
        background: {
            base: '#ffa42b',
            highlight: '#ffb656',
            press: '#ee8800',
            elevated: { base: '#ffb656', highlight: '#ffb656', press: '#ee8800' },
            tinted: { base: '#ffa42b', highlight: '#ffa42b', press: '#ffa42b' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#f18900' },
    },
    warningSubdued: {
        background: {
            base: '#ffd97e',
            highlight: '#ffeab8',
            press: '#ffb504',
            elevated: { base: '#ffeab8', highlight: '#ffeab8', press: '#ffb504' },
            tinted: { base: '#ffd97e', highlight: '#ffd97e', press: '#ffd97e' },
        },
        text: {
            base: '#491e00',
            subdued: '#491e00',
            brightAccent: '#491e00',
            negative: '#491e00',
            warning: '#491e00',
            positive: '#491e00',
            announcement: '#491e00',
        },
        essential: {
            base: '#491e00',
            subdued: '#491e00',
            brightAccent: '#491e00',
            negative: '#491e00',
            warning: '#491e00',
            positive: '#491e00',
            announcement: '#491e00',
        },
        decorative: { base: '#491e00', subdued: '#ffc742' },
    },
    positive: {
        background: {
            base: '#1ed760',
            highlight: '#3be477',
            press: '#1abc54',
            elevated: { base: '#3be477', highlight: '#3be477', press: '#1abc54' },
            tinted: { base: '#1ed760', highlight: '#1ed760', press: '#1ed760' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#1abc54' },
    },
    positiveSubdued: {
        background: {
            base: '#96f0b6',
            highlight: '#c5f7d7',
            press: '#21df65',
            elevated: { base: '#c5f7d7', highlight: '#c5f7d7', press: '#21df65' },
            tinted: { base: '#96f0b6', highlight: '#96f0b6', press: '#96f0b6' },
        },
        text: {
            base: '#073116',
            subdued: '#073116',
            brightAccent: '#073116',
            negative: '#073116',
            warning: '#073116',
            positive: '#073116',
            announcement: '#073116',
        },
        essential: {
            base: '#073116',
            subdued: '#073116',
            brightAccent: '#073116',
            negative: '#073116',
            warning: '#073116',
            positive: '#073116',
            announcement: '#073116',
        },
        decorative: { base: '#073116', subdued: '#60e890' },
    },
    announcement: {
        background: {
            base: '#0074e0',
            highlight: '#006bcf',
            press: '#00529e',
            elevated: { base: '#006bcf', highlight: '#006bcf', press: '#00529e' },
            tinted: { base: '#0074e0', highlight: '#0074e0', press: '#0074e0' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#0386ff' },
    },
    announcementSubdued: {
        background: {
            base: '#b5e4ff',
            highlight: '#d5f0ff',
            press: '#75cdff',
            elevated: { base: '#d5f0ff', highlight: '#d5f0ff', press: '#75cdff' },
            tinted: { base: '#b5e4ff', highlight: '#b5e4ff', press: '#b5e4ff' },
        },
        text: {
            base: '#052a56',
            subdued: '#052a56',
            brightAccent: '#052a56',
            negative: '#052a56',
            warning: '#052a56',
            positive: '#052a56',
            announcement: '#052a56',
        },
        essential: {
            base: '#052a56',
            subdued: '#052a56',
            brightAccent: '#052a56',
            negative: '#052a56',
            warning: '#052a56',
            positive: '#052a56',
            announcement: '#052a56',
        },
        decorative: { base: '#052a56', subdued: '#85d3ff' },
    },
    invertedDark: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#343434',
            elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
            tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
        },
        text: {
            base: '#ffffff',
            subdued: '#939393',
            brightAccent: '#9691ff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#626262',
            brightAccent: '#9691ff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    invertedLight: {
        background: {
            base: '#ffffff',
            highlight: '#f0f0f0',
            press: '#c7c7c7',
            elevated: { base: '#f0f0f0', highlight: '#f0f0f0', press: '#c7c7c7' },
            tinted: { base: '#ffffff', highlight: '#ffffff', press: '#ffffff' },
        },
        text: {
            base: '#000000',
            subdued: '#5a5a5a',
            brightAccent: '#5a52ff',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#8a8a8a',
            brightAccent: '#8079ff',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    inverted: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#343434',
            elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
            tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
        },
        text: {
            base: '#ffffff',
            subdued: '#939393',
            brightAccent: '#9691ff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#626262',
            brightAccent: '#9691ff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    mutedAccent: {
        background: {
            base: '#121212',
            highlight: '#1b1b1b',
            press: '#040404',
            elevated: { base: '#1b1b1b', highlight: '#232323', press: '#171717' },
            tinted: {
                base: 'rgba(255, 255, 255, 0.07)',
                highlight: 'rgba(255, 255, 255, 0.1)',
                press: 'rgba(255, 255, 255, 0.15)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#a7a7a7',
            brightAccent: '#9691ff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#727272',
            brightAccent: '#9691ff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#292929' },
    },
    overMedia: {
        background: {
            base: 'rgba(0, 0, 0, 0.54)',
            highlight: 'rgba(0, 0, 0, 0.58)',
            press: 'rgba(0, 0, 0, 0.68)',
            elevated: {
                base: 'rgba(0, 0, 0, 0.58)',
                highlight: 'rgba(0, 0, 0, 0.58)',
                press: 'rgba(0, 0, 0, 0.68)',
            },
            tinted: {
                base: 'rgba(0, 0, 0, 0.54)',
                highlight: 'rgba(0, 0, 0, 0.54)',
                press: 'rgba(0, 0, 0, 0.54)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: 'rgba(255, 255, 255, 0.13)' },
    },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * The S4C Dark theme is used for Spotify Creator Studio, a product used to create, distribute, and monetize podcasts.
 */
export var s4cDarkTheme = {
    base: {
        background: {
            base: '#121212',
            highlight: '#1f1f1f',
            press: '#000000',
            elevated: { base: '#1f1f1f', highlight: '#2a2a2a', press: '#191919' },
            tinted: {
                base: 'rgba(255, 255, 255, 0.1)',
                highlight: 'rgba(255, 255, 255, 0.14)',
                press: 'rgba(255, 255, 255, 0.21)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#b3b3b3',
            brightAccent: '#9691ff',
            negative: '#f3727f',
            warning: '#ffa42b',
            positive: '#1ed760',
            announcement: '#4cb3ff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#7c7c7c',
            brightAccent: '#9691ff',
            negative: '#ed2c3f',
            warning: '#ffa42b',
            positive: '#1ed760',
            announcement: '#4cb3ff',
        },
        decorative: { base: '#ffffff', subdued: '#292929' },
    },
    brightAccent: {
        background: {
            base: '#9691ff',
            highlight: '#a39eff',
            press: '#7e77ff',
            elevated: { base: '#a39eff', highlight: '#a39eff', press: '#7e77ff' },
            tinted: { base: '#9691ff', highlight: '#9691ff', press: '#9691ff' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#807aff' },
    },
    negative: {
        background: {
            base: '#e91429',
            highlight: '#d81326',
            press: '#a60e1d',
            elevated: { base: '#d81326', highlight: '#d81326', press: '#a60e1d' },
            tinted: { base: '#e91429', highlight: '#e91429', press: '#e91429' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#ee3a4c' },
    },
    negativeSubdued: {
        background: {
            base: '#590810',
            highlight: '#6b0a13',
            press: '#9b0e1c',
            elevated: { base: '#6b0a13', highlight: '#6b0a13', press: '#9b0e1c' },
            tinted: { base: '#590810', highlight: '#590810', press: '#590810' },
        },
        text: {
            base: '#ffd2d7',
            subdued: '#ffd2d7',
            brightAccent: '#ffd2d7',
            negative: '#ffd2d7',
            warning: '#ffd2d7',
            positive: '#ffd2d7',
            announcement: '#ffd2d7',
        },
        essential: {
            base: '#ffd2d7',
            subdued: '#ffd2d7',
            brightAccent: '#ffd2d7',
            negative: '#ffd2d7',
            warning: '#ffd2d7',
            positive: '#ffd2d7',
            announcement: '#ffd2d7',
        },
        decorative: { base: '#ffd2d7', subdued: '#7b0b16' },
    },
    warning: {
        background: {
            base: '#ffa42b',
            highlight: '#ffb656',
            press: '#ee8800',
            elevated: { base: '#ffb656', highlight: '#ffb656', press: '#ee8800' },
            tinted: { base: '#ffa42b', highlight: '#ffa42b', press: '#ffa42b' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#f18900' },
    },
    warningSubdued: {
        background: {
            base: '#491e00',
            highlight: '#582400',
            press: '#833600',
            elevated: { base: '#582400', highlight: '#582400', press: '#833600' },
            tinted: { base: '#491e00', highlight: '#491e00', press: '#491e00' },
        },
        text: {
            base: '#ffd97e',
            subdued: '#ffd97e',
            brightAccent: '#ffd97e',
            negative: '#ffd97e',
            warning: '#ffd97e',
            positive: '#ffd97e',
            announcement: '#ffd97e',
        },
        essential: {
            base: '#ffd97e',
            subdued: '#ffd97e',
            brightAccent: '#ffd97e',
            negative: '#ffd97e',
            warning: '#ffd97e',
            positive: '#ffd97e',
            announcement: '#ffd97e',
        },
        decorative: { base: '#ffd97e', subdued: '#652a00' },
    },
    positive: {
        background: {
            base: '#1ed760',
            highlight: '#3be477',
            press: '#1abc54',
            elevated: { base: '#3be477', highlight: '#3be477', press: '#1abc54' },
            tinted: { base: '#1ed760', highlight: '#1ed760', press: '#1ed760' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#1abc54' },
    },
    positiveSubdued: {
        background: {
            base: '#073116',
            highlight: '#093c1b',
            press: '#0d5928',
            elevated: { base: '#093c1b', highlight: '#093c1b', press: '#0d5928' },
            tinted: { base: '#073116', highlight: '#073116', press: '#073116' },
        },
        text: {
            base: '#96f0b6',
            subdued: '#96f0b6',
            brightAccent: '#96f0b6',
            negative: '#96f0b6',
            warning: '#96f0b6',
            positive: '#96f0b6',
            announcement: '#96f0b6',
        },
        essential: {
            base: '#96f0b6',
            subdued: '#96f0b6',
            brightAccent: '#96f0b6',
            negative: '#96f0b6',
            warning: '#96f0b6',
            positive: '#96f0b6',
            announcement: '#96f0b6',
        },
        decorative: { base: '#96f0b6', subdued: '#0a4620' },
    },
    announcement: {
        background: {
            base: '#4cb3ff',
            highlight: '#69bfff',
            press: '#109aff',
            elevated: { base: '#69bfff', highlight: '#69bfff', press: '#109aff' },
            tinted: { base: '#4cb3ff', highlight: '#4cb3ff', press: '#4cb3ff' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#159cff' },
    },
    announcementSubdued: {
        background: {
            base: '#00285d',
            highlight: '#003171',
            press: '#0048a7',
            elevated: { base: '#003171', highlight: '#003171', press: '#0048a7' },
            tinted: { base: '#00285d', highlight: '#00285d', press: '#00285d' },
        },
        text: {
            base: '#c8e0fc',
            subdued: '#c8e0fc',
            brightAccent: '#c8e0fc',
            negative: '#c8e0fc',
            warning: '#c8e0fc',
            positive: '#c8e0fc',
            announcement: '#c8e0fc',
        },
        essential: {
            base: '#c8e0fc',
            subdued: '#c8e0fc',
            brightAccent: '#c8e0fc',
            negative: '#c8e0fc',
            warning: '#c8e0fc',
            positive: '#c8e0fc',
            announcement: '#c8e0fc',
        },
        decorative: { base: '#c8e0fc', subdued: '#003985' },
    },
    invertedDark: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#343434',
            elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
            tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
        },
        text: {
            base: '#ffffff',
            subdued: '#939393',
            brightAccent: '#9691ff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#626262',
            brightAccent: '#9691ff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    invertedLight: {
        background: {
            base: '#ffffff',
            highlight: '#f0f0f0',
            press: '#c7c7c7',
            elevated: { base: '#f0f0f0', highlight: '#f0f0f0', press: '#c7c7c7' },
            tinted: { base: '#ffffff', highlight: '#ffffff', press: '#ffffff' },
        },
        text: {
            base: '#000000',
            subdued: '#5a5a5a',
            brightAccent: '#5a52ff',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#8a8a8a',
            brightAccent: '#8079ff',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    inverted: {
        background: {
            base: '#ffffff',
            highlight: '#f0f0f0',
            press: '#c7c7c7',
            elevated: { base: '#f0f0f0', highlight: '#f0f0f0', press: '#c7c7c7' },
            tinted: { base: '#ffffff', highlight: '#ffffff', press: '#ffffff' },
        },
        text: {
            base: '#000000',
            subdued: '#5a5a5a',
            brightAccent: '#5a52ff',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#8a8a8a',
            brightAccent: '#8079ff',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    mutedAccent: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#2b2b2b',
            elevated: { base: '#141414', highlight: '#212121', press: '#0b0b0b' },
            tinted: {
                base: 'rgba(255, 255, 255, 0.13)',
                highlight: 'rgba(255, 255, 255, 0.17)',
                press: 'rgba(255, 255, 255, 0.24)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#a9a9a9',
            brightAccent: '#9691ff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#747474',
            brightAccent: '#9691ff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    overMedia: {
        background: {
            base: 'rgba(0, 0, 0, 0.54)',
            highlight: 'rgba(0, 0, 0, 0.58)',
            press: 'rgba(0, 0, 0, 0.68)',
            elevated: {
                base: 'rgba(0, 0, 0, 0.58)',
                highlight: 'rgba(0, 0, 0, 0.58)',
                press: 'rgba(0, 0, 0, 0.68)',
            },
            tinted: {
                base: 'rgba(0, 0, 0, 0.54)',
                highlight: 'rgba(0, 0, 0, 0.54)',
                press: 'rgba(0, 0, 0, 0.54)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: 'rgba(255, 255, 255, 0.13)' },
    },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 * The Megaphone Light theme is used for the Megaphone CMS, a product to publish, monetize, and measure podcasts.
 */
export var megaphoneLightTheme = {
    base: {
        background: {
            base: '#ffffff',
            highlight: '#f5f5f5',
            press: '#e2e2e2',
            elevated: { base: '#ffffff', highlight: '#f5f5f5', press: '#e7e7e7' },
            tinted: {
                base: 'rgba(0, 0, 0, 0.08)',
                highlight: 'rgba(0, 0, 0, 0.12)',
                press: 'rgba(0, 0, 0, 0.19)',
            },
        },
        text: {
            base: '#000000',
            subdued: '#656565',
            brightAccent: '#5d3eff',
            negative: '#c91123',
            warning: '#955500',
            positive: '#107434',
            announcement: '#45688a',
        },
        essential: {
            base: '#000000',
            subdued: '#818181',
            brightAccent: '#7358ff',
            negative: '#e91429',
            warning: '#bf6d00',
            positive: '#159542',
            announcement: '#5179a1',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    brightAccent: {
        background: {
            base: '#7358ff',
            highlight: '#674aff',
            press: '#3912ff',
            elevated: { base: '#674aff', highlight: '#674aff', press: '#3912ff' },
            tinted: { base: '#7358ff', highlight: '#7358ff', press: '#7358ff' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#876fff' },
    },
    negative: {
        background: {
            base: '#e91429',
            highlight: '#d81326',
            press: '#a60e1d',
            elevated: { base: '#d81326', highlight: '#d81326', press: '#a60e1d' },
            tinted: { base: '#e91429', highlight: '#e91429', press: '#e91429' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#ee3a4c' },
    },
    negativeSubdued: {
        background: {
            base: '#ffd2d7',
            highlight: '#ffe5e8',
            press: '#ffadb6',
            elevated: { base: '#ffe5e8', highlight: '#ffe5e8', press: '#ffadb6' },
            tinted: { base: '#ffd2d7', highlight: '#ffd2d7', press: '#ffd2d7' },
        },
        text: {
            base: '#590810',
            subdued: '#590810',
            brightAccent: '#590810',
            negative: '#590810',
            warning: '#590810',
            positive: '#590810',
            announcement: '#590810',
        },
        essential: {
            base: '#590810',
            subdued: '#590810',
            brightAccent: '#590810',
            negative: '#590810',
            warning: '#590810',
            positive: '#590810',
            announcement: '#590810',
        },
        decorative: { base: '#590810', subdued: '#ffb9c1' },
    },
    warning: {
        background: {
            base: '#ffa42b',
            highlight: '#ffb656',
            press: '#ee8800',
            elevated: { base: '#ffb656', highlight: '#ffb656', press: '#ee8800' },
            tinted: { base: '#ffa42b', highlight: '#ffa42b', press: '#ffa42b' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#f18900' },
    },
    warningSubdued: {
        background: {
            base: '#ffd97e',
            highlight: '#ffeab8',
            press: '#ffb504',
            elevated: { base: '#ffeab8', highlight: '#ffeab8', press: '#ffb504' },
            tinted: { base: '#ffd97e', highlight: '#ffd97e', press: '#ffd97e' },
        },
        text: {
            base: '#491e00',
            subdued: '#491e00',
            brightAccent: '#491e00',
            negative: '#491e00',
            warning: '#491e00',
            positive: '#491e00',
            announcement: '#491e00',
        },
        essential: {
            base: '#491e00',
            subdued: '#491e00',
            brightAccent: '#491e00',
            negative: '#491e00',
            warning: '#491e00',
            positive: '#491e00',
            announcement: '#491e00',
        },
        decorative: { base: '#491e00', subdued: '#ffc742' },
    },
    positive: {
        background: {
            base: '#1ed760',
            highlight: '#3be477',
            press: '#1abc54',
            elevated: { base: '#3be477', highlight: '#3be477', press: '#1abc54' },
            tinted: { base: '#1ed760', highlight: '#1ed760', press: '#1ed760' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#1abc54' },
    },
    positiveSubdued: {
        background: {
            base: '#96f0b6',
            highlight: '#c5f7d7',
            press: '#21df65',
            elevated: { base: '#c5f7d7', highlight: '#c5f7d7', press: '#21df65' },
            tinted: { base: '#96f0b6', highlight: '#96f0b6', press: '#96f0b6' },
        },
        text: {
            base: '#073116',
            subdued: '#073116',
            brightAccent: '#073116',
            negative: '#073116',
            warning: '#073116',
            positive: '#073116',
            announcement: '#073116',
        },
        essential: {
            base: '#073116',
            subdued: '#073116',
            brightAccent: '#073116',
            negative: '#073116',
            warning: '#073116',
            positive: '#073116',
            announcement: '#073116',
        },
        decorative: { base: '#073116', subdued: '#60e890' },
    },
    announcement: {
        background: {
            base: '#0d72ea',
            highlight: '#1b7df2',
            press: '#0b61c7',
            elevated: { base: '#1b7df2', highlight: '#1b7df2', press: '#0b61c7' },
            tinted: { base: '#0d72ea', highlight: '#0d72ea', press: '#0d72ea' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#0b61c8' },
    },
    announcementSubdued: {
        background: {
            base: '#b5e4ff',
            highlight: '#d5f0ff',
            press: '#75cdff',
            elevated: { base: '#d5f0ff', highlight: '#d5f0ff', press: '#75cdff' },
            tinted: { base: '#b5e4ff', highlight: '#b5e4ff', press: '#b5e4ff' },
        },
        text: {
            base: '#052a56',
            subdued: '#052a56',
            brightAccent: '#052a56',
            negative: '#052a56',
            warning: '#052a56',
            positive: '#052a56',
            announcement: '#052a56',
        },
        essential: {
            base: '#052a56',
            subdued: '#052a56',
            brightAccent: '#052a56',
            negative: '#052a56',
            warning: '#052a56',
            positive: '#052a56',
            announcement: '#052a56',
        },
        decorative: { base: '#052a56', subdued: '#85d3ff' },
    },
    invertedDark: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#343434',
            elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
            tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
        },
        text: {
            base: '#ffffff',
            subdued: '#939393',
            brightAccent: '#7d64ff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#626262',
            brightAccent: '#7358ff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    invertedLight: {
        background: {
            base: '#ffffff',
            highlight: '#f0f0f0',
            press: '#c7c7c7',
            elevated: { base: '#f0f0f0', highlight: '#f0f0f0', press: '#c7c7c7' },
            tinted: { base: '#ffffff', highlight: '#ffffff', press: '#ffffff' },
        },
        text: {
            base: '#000000',
            subdued: '#5a5a5a',
            brightAccent: '#694cff',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#8a8a8a',
            brightAccent: '#7358ff',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    inverted: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#343434',
            elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
            tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
        },
        text: {
            base: '#ffffff',
            subdued: '#939393',
            brightAccent: '#7d64ff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#626262',
            brightAccent: '#7358ff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    mutedAccent: {
        background: {
            base: '#121212',
            highlight: '#1b1b1b',
            press: '#040404',
            elevated: { base: '#1b1b1b', highlight: '#232323', press: '#171717' },
            tinted: {
                base: 'rgba(255, 255, 255, 0.07)',
                highlight: 'rgba(255, 255, 255, 0.1)',
                press: 'rgba(255, 255, 255, 0.15)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#a7a7a7',
            brightAccent: '#927dff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#727272',
            brightAccent: '#7358ff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#292929' },
    },
    overMedia: {
        background: {
            base: 'rgba(0, 0, 0, 0.54)',
            highlight: 'rgba(0, 0, 0, 0.58)',
            press: 'rgba(0, 0, 0, 0.68)',
            elevated: {
                base: 'rgba(0, 0, 0, 0.58)',
                highlight: 'rgba(0, 0, 0, 0.58)',
                press: 'rgba(0, 0, 0, 0.68)',
            },
            tinted: {
                base: 'rgba(0, 0, 0, 0.54)',
                highlight: 'rgba(0, 0, 0, 0.54)',
                press: 'rgba(0, 0, 0, 0.54)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: 'rgba(255, 255, 255, 0.13)' },
    },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 * The Ad Analytics Light theme is used for the Ad Analytics product, a product to measure the performance of advertising campaigns.
 */
export var adAnalyticsLightTheme = {
    base: {
        background: {
            base: '#ffffff',
            highlight: '#f5f5f5',
            press: '#e2e2e2',
            elevated: { base: '#ffffff', highlight: '#f5f5f5', press: '#e7e7e7' },
            tinted: {
                base: 'rgba(0, 0, 0, 0.08)',
                highlight: 'rgba(0, 0, 0, 0.12)',
                press: 'rgba(0, 0, 0, 0.19)',
            },
        },
        text: {
            base: '#000000',
            subdued: '#656565',
            brightAccent: '#526e07',
            negative: '#c91123',
            warning: '#955500',
            positive: '#107434',
            announcement: '#0064c1',
        },
        essential: {
            base: '#000000',
            subdued: '#818181',
            brightAccent: '#698c09',
            negative: '#e91429',
            warning: '#bf6d00',
            positive: '#159542',
            announcement: '#0074e0',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    brightAccent: {
        background: {
            base: '#cff56a',
            highlight: '#eefccb',
            press: '#a5de0f',
            elevated: { base: '#eefccb', highlight: '#eefccb', press: '#a5de0f' },
            tinted: { base: '#cff56a', highlight: '#cff56a', press: '#cff56a' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#a8e20f' },
    },
    negative: {
        background: {
            base: '#e91429',
            highlight: '#d81326',
            press: '#a60e1d',
            elevated: { base: '#d81326', highlight: '#d81326', press: '#a60e1d' },
            tinted: { base: '#e91429', highlight: '#e91429', press: '#e91429' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#ee3a4c' },
    },
    negativeSubdued: {
        background: {
            base: '#ffd2d7',
            highlight: '#ffe5e8',
            press: '#ffadb6',
            elevated: { base: '#ffe5e8', highlight: '#ffe5e8', press: '#ffadb6' },
            tinted: { base: '#ffd2d7', highlight: '#ffd2d7', press: '#ffd2d7' },
        },
        text: {
            base: '#590810',
            subdued: '#590810',
            brightAccent: '#590810',
            negative: '#590810',
            warning: '#590810',
            positive: '#590810',
            announcement: '#590810',
        },
        essential: {
            base: '#590810',
            subdued: '#590810',
            brightAccent: '#590810',
            negative: '#590810',
            warning: '#590810',
            positive: '#590810',
            announcement: '#590810',
        },
        decorative: { base: '#590810', subdued: '#ffb9c1' },
    },
    warning: {
        background: {
            base: '#ffa42b',
            highlight: '#ffb656',
            press: '#ee8800',
            elevated: { base: '#ffb656', highlight: '#ffb656', press: '#ee8800' },
            tinted: { base: '#ffa42b', highlight: '#ffa42b', press: '#ffa42b' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#f18900' },
    },
    warningSubdued: {
        background: {
            base: '#ffd97e',
            highlight: '#ffeab8',
            press: '#ffb504',
            elevated: { base: '#ffeab8', highlight: '#ffeab8', press: '#ffb504' },
            tinted: { base: '#ffd97e', highlight: '#ffd97e', press: '#ffd97e' },
        },
        text: {
            base: '#491e00',
            subdued: '#491e00',
            brightAccent: '#491e00',
            negative: '#491e00',
            warning: '#491e00',
            positive: '#491e00',
            announcement: '#491e00',
        },
        essential: {
            base: '#491e00',
            subdued: '#491e00',
            brightAccent: '#491e00',
            negative: '#491e00',
            warning: '#491e00',
            positive: '#491e00',
            announcement: '#491e00',
        },
        decorative: { base: '#491e00', subdued: '#ffc742' },
    },
    positive: {
        background: {
            base: '#1ed760',
            highlight: '#3be477',
            press: '#1abc54',
            elevated: { base: '#3be477', highlight: '#3be477', press: '#1abc54' },
            tinted: { base: '#1ed760', highlight: '#1ed760', press: '#1ed760' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#1abc54' },
    },
    positiveSubdued: {
        background: {
            base: '#96f0b6',
            highlight: '#c5f7d7',
            press: '#21df65',
            elevated: { base: '#c5f7d7', highlight: '#c5f7d7', press: '#21df65' },
            tinted: { base: '#96f0b6', highlight: '#96f0b6', press: '#96f0b6' },
        },
        text: {
            base: '#073116',
            subdued: '#073116',
            brightAccent: '#073116',
            negative: '#073116',
            warning: '#073116',
            positive: '#073116',
            announcement: '#073116',
        },
        essential: {
            base: '#073116',
            subdued: '#073116',
            brightAccent: '#073116',
            negative: '#073116',
            warning: '#073116',
            positive: '#073116',
            announcement: '#073116',
        },
        decorative: { base: '#073116', subdued: '#60e890' },
    },
    announcement: {
        background: {
            base: '#0074e0',
            highlight: '#006bcf',
            press: '#00529e',
            elevated: { base: '#006bcf', highlight: '#006bcf', press: '#00529e' },
            tinted: { base: '#0074e0', highlight: '#0074e0', press: '#0074e0' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#0386ff' },
    },
    announcementSubdued: {
        background: {
            base: '#b5e4ff',
            highlight: '#d5f0ff',
            press: '#75cdff',
            elevated: { base: '#d5f0ff', highlight: '#d5f0ff', press: '#75cdff' },
            tinted: { base: '#b5e4ff', highlight: '#b5e4ff', press: '#b5e4ff' },
        },
        text: {
            base: '#052a56',
            subdued: '#052a56',
            brightAccent: '#052a56',
            negative: '#052a56',
            warning: '#052a56',
            positive: '#052a56',
            announcement: '#052a56',
        },
        essential: {
            base: '#052a56',
            subdued: '#052a56',
            brightAccent: '#052a56',
            negative: '#052a56',
            warning: '#052a56',
            positive: '#052a56',
            announcement: '#052a56',
        },
        decorative: { base: '#052a56', subdued: '#85d3ff' },
    },
    invertedDark: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#343434',
            elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
            tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
        },
        text: {
            base: '#ffffff',
            subdued: '#939393',
            brightAccent: '#cff56a',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#626262',
            brightAccent: '#cff56a',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    invertedLight: {
        background: {
            base: '#ffffff',
            highlight: '#f0f0f0',
            press: '#c7c7c7',
            elevated: { base: '#f0f0f0', highlight: '#f0f0f0', press: '#c7c7c7' },
            tinted: { base: '#ffffff', highlight: '#ffffff', press: '#ffffff' },
        },
        text: {
            base: '#000000',
            subdued: '#5a5a5a',
            brightAccent: '#597708',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#8a8a8a',
            brightAccent: '#70970a',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    inverted: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#343434',
            elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
            tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
        },
        text: {
            base: '#ffffff',
            subdued: '#939393',
            brightAccent: '#cff56a',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#626262',
            brightAccent: '#cff56a',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    mutedAccent: {
        background: {
            base: '#121212',
            highlight: '#1b1b1b',
            press: '#040404',
            elevated: { base: '#1b1b1b', highlight: '#232323', press: '#171717' },
            tinted: {
                base: 'rgba(255, 255, 255, 0.07)',
                highlight: 'rgba(255, 255, 255, 0.1)',
                press: 'rgba(255, 255, 255, 0.15)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#a7a7a7',
            brightAccent: '#cff56a',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#727272',
            brightAccent: '#cff56a',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#292929' },
    },
    overMedia: {
        background: {
            base: 'rgba(0, 0, 0, 0.54)',
            highlight: 'rgba(0, 0, 0, 0.58)',
            press: 'rgba(0, 0, 0, 0.68)',
            elevated: {
                base: 'rgba(0, 0, 0, 0.58)',
                highlight: 'rgba(0, 0, 0, 0.58)',
                press: 'rgba(0, 0, 0, 0.68)',
            },
            tinted: {
                base: 'rgba(0, 0, 0, 0.54)',
                highlight: 'rgba(0, 0, 0, 0.54)',
                press: 'rgba(0, 0, 0, 0.54)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: 'rgba(255, 255, 255, 0.13)' },
    },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * The TV Dark theme is used for Spotify TV, the consumer client for TV devices. It's mostly identical to the dark theme, but contains tweaked versions of green and red colors to minimize bleeding on older TVs.
 */
export var tvDarkTheme = {
    base: {
        background: {
            base: '#1b1b1f',
            highlight: '#26262c',
            press: '#0b0b0d',
            elevated: { base: '#26262c', highlight: '#303037', press: '#212125' },
            tinted: {
                base: 'rgba(255, 255, 255, 0.1)',
                highlight: 'rgba(255, 255, 255, 0.14)',
                press: 'rgba(255, 255, 255, 0.22)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#babac3',
            brightAccent: '#1dba55',
            negative: '#ee828c',
            warning: '#ffa42b',
            positive: '#1dba55',
            announcement: '#4cb3ff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#818191',
            brightAccent: '#1db854',
            negative: '#e64958',
            warning: '#ffa42b',
            positive: '#1db854',
            announcement: '#4cb3ff',
        },
        decorative: { base: '#ffffff', subdued: '#303037' },
    },
    brightAccent: {
        background: {
            base: '#1db854',
            highlight: '#1fc55a',
            press: '#19a049',
            elevated: { base: '#1fc55a', highlight: '#1fc55a', press: '#19a049' },
            tinted: { base: '#1db854', highlight: '#1db854', press: '#1db854' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#19a049' },
    },
    negative: {
        background: {
            base: '#aa1725',
            highlight: '#9a1522',
            press: '#6a0e17',
            elevated: { base: '#9a1522', highlight: '#9a1522', press: '#6a0e17' },
            tinted: { base: '#aa1725', highlight: '#aa1725', press: '#aa1725' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#cc1c2c' },
    },
    negativeSubdued: {
        background: {
            base: '#590810',
            highlight: '#6b0a13',
            press: '#9b0e1c',
            elevated: { base: '#6b0a13', highlight: '#6b0a13', press: '#9b0e1c' },
            tinted: { base: '#590810', highlight: '#590810', press: '#590810' },
        },
        text: {
            base: '#ffd2d7',
            subdued: '#ffd2d7',
            brightAccent: '#ffd2d7',
            negative: '#ffd2d7',
            warning: '#ffd2d7',
            positive: '#ffd2d7',
            announcement: '#ffd2d7',
        },
        essential: {
            base: '#ffd2d7',
            subdued: '#ffd2d7',
            brightAccent: '#ffd2d7',
            negative: '#ffd2d7',
            warning: '#ffd2d7',
            positive: '#ffd2d7',
            announcement: '#ffd2d7',
        },
        decorative: { base: '#ffd2d7', subdued: '#7b0b16' },
    },
    warning: {
        background: {
            base: '#ffa42b',
            highlight: '#ffb656',
            press: '#ee8800',
            elevated: { base: '#ffb656', highlight: '#ffb656', press: '#ee8800' },
            tinted: { base: '#ffa42b', highlight: '#ffa42b', press: '#ffa42b' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#f18900' },
    },
    warningSubdued: {
        background: {
            base: '#491e00',
            highlight: '#582400',
            press: '#833600',
            elevated: { base: '#582400', highlight: '#582400', press: '#833600' },
            tinted: { base: '#491e00', highlight: '#491e00', press: '#491e00' },
        },
        text: {
            base: '#ffd97e',
            subdued: '#ffd97e',
            brightAccent: '#ffd97e',
            negative: '#ffd97e',
            warning: '#ffd97e',
            positive: '#ffd97e',
            announcement: '#ffd97e',
        },
        essential: {
            base: '#ffd97e',
            subdued: '#ffd97e',
            brightAccent: '#ffd97e',
            negative: '#ffd97e',
            warning: '#ffd97e',
            positive: '#ffd97e',
            announcement: '#ffd97e',
        },
        decorative: { base: '#ffd97e', subdued: '#652a00' },
    },
    positive: {
        background: {
            base: '#1db854',
            highlight: '#1fc55a',
            press: '#19a049',
            elevated: { base: '#1fc55a', highlight: '#1fc55a', press: '#19a049' },
            tinted: { base: '#1db854', highlight: '#1db854', press: '#1db854' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#19a049' },
    },
    positiveSubdued: {
        background: {
            base: '#073116',
            highlight: '#093c1b',
            press: '#0d5928',
            elevated: { base: '#093c1b', highlight: '#093c1b', press: '#0d5928' },
            tinted: { base: '#073116', highlight: '#073116', press: '#073116' },
        },
        text: {
            base: '#96f0b6',
            subdued: '#96f0b6',
            brightAccent: '#96f0b6',
            negative: '#96f0b6',
            warning: '#96f0b6',
            positive: '#96f0b6',
            announcement: '#96f0b6',
        },
        essential: {
            base: '#96f0b6',
            subdued: '#96f0b6',
            brightAccent: '#96f0b6',
            negative: '#96f0b6',
            warning: '#96f0b6',
            positive: '#96f0b6',
            announcement: '#96f0b6',
        },
        decorative: { base: '#96f0b6', subdued: '#0a4620' },
    },
    announcement: {
        background: {
            base: '#4cb3ff',
            highlight: '#69bfff',
            press: '#109aff',
            elevated: { base: '#69bfff', highlight: '#69bfff', press: '#109aff' },
            tinted: { base: '#4cb3ff', highlight: '#4cb3ff', press: '#4cb3ff' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#159cff' },
    },
    announcementSubdued: {
        background: {
            base: '#00285d',
            highlight: '#003171',
            press: '#0048a7',
            elevated: { base: '#003171', highlight: '#003171', press: '#0048a7' },
            tinted: { base: '#00285d', highlight: '#00285d', press: '#00285d' },
        },
        text: {
            base: '#c8e0fc',
            subdued: '#c8e0fc',
            brightAccent: '#c8e0fc',
            negative: '#c8e0fc',
            warning: '#c8e0fc',
            positive: '#c8e0fc',
            announcement: '#c8e0fc',
        },
        essential: {
            base: '#c8e0fc',
            subdued: '#c8e0fc',
            brightAccent: '#c8e0fc',
            negative: '#c8e0fc',
            warning: '#c8e0fc',
            positive: '#c8e0fc',
            announcement: '#c8e0fc',
        },
        decorative: { base: '#c8e0fc', subdued: '#003985' },
    },
    invertedDark: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#343434',
            elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
            tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
        },
        text: {
            base: '#ffffff',
            subdued: '#939393',
            brightAccent: '#1db854',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#626262',
            brightAccent: '#1db854',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    invertedLight: {
        background: {
            base: '#ffffff',
            highlight: '#f0f0f0',
            press: '#c7c7c7',
            elevated: { base: '#f0f0f0', highlight: '#f0f0f0', press: '#c7c7c7' },
            tinted: { base: '#ffffff', highlight: '#ffffff', press: '#ffffff' },
        },
        text: {
            base: '#000000',
            subdued: '#5a5a5a',
            brightAccent: '#147e3a',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#8a8a8a',
            brightAccent: '#199f49',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    inverted: {
        background: {
            base: '#ffffff',
            highlight: '#f0f0f0',
            press: '#c7c7c7',
            elevated: { base: '#f0f0f0', highlight: '#f0f0f0', press: '#c7c7c7' },
            tinted: { base: '#ffffff', highlight: '#ffffff', press: '#ffffff' },
        },
        text: {
            base: '#000000',
            subdued: '#5a5a5a',
            brightAccent: '#147e3a',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#8a8a8a',
            brightAccent: '#199f49',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    mutedAccent: {
        background: {
            base: '#111114',
            highlight: '#1f1f23',
            press: '#000000',
            elevated: { base: '#1f1f23', highlight: '#29292f', press: '#18181c' },
            tinted: {
                base: 'rgba(255, 255, 255, 0.11)',
                highlight: 'rgba(255, 255, 255, 0.15)',
                press: 'rgba(255, 255, 255, 0.22)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#b2b2bc',
            brightAccent: '#1db854',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#7a7a8b',
            brightAccent: '#1db854',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#27272c' },
    },
    overMedia: {
        background: {
            base: 'rgba(0, 0, 0, 0.54)',
            highlight: 'rgba(0, 0, 0, 0.58)',
            press: 'rgba(0, 0, 0, 0.68)',
            elevated: {
                base: 'rgba(0, 0, 0, 0.58)',
                highlight: 'rgba(0, 0, 0, 0.58)',
                press: 'rgba(0, 0, 0, 0.68)',
            },
            tinted: {
                base: 'rgba(0, 0, 0, 0.54)',
                highlight: 'rgba(0, 0, 0, 0.54)',
                press: 'rgba(0, 0, 0, 0.54)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: 'rgba(255, 255, 255, 0.13)' },
    },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 * The dark theme for wearables. Using a pure black background to eliminate the need to override colors.
 */
export var wearablesDarkTheme = {
    base: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#2b2b2b',
            elevated: { base: '#141414', highlight: '#212121', press: '#0b0b0b' },
            tinted: {
                base: 'rgba(255, 255, 255, 0.13)',
                highlight: 'rgba(255, 255, 255, 0.17)',
                press: 'rgba(255, 255, 255, 0.24)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#a9a9a9',
            brightAccent: '#1ed760',
            negative: '#f1616f',
            warning: '#ffa42b',
            positive: '#1ed760',
            announcement: '#4cb3ff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#747474',
            brightAccent: '#1ed760',
            negative: '#e91429',
            warning: '#ffa42b',
            positive: '#1ed760',
            announcement: '#4cb3ff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    brightAccent: {
        background: {
            base: '#1ed760',
            highlight: '#3be477',
            press: '#1abc54',
            elevated: { base: '#3be477', highlight: '#3be477', press: '#1abc54' },
            tinted: { base: '#1ed760', highlight: '#1ed760', press: '#1ed760' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#1abc54' },
    },
    negative: {
        background: {
            base: '#e91429',
            highlight: '#d81326',
            press: '#a60e1d',
            elevated: { base: '#d81326', highlight: '#d81326', press: '#a60e1d' },
            tinted: { base: '#e91429', highlight: '#e91429', press: '#e91429' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#ee3a4c' },
    },
    negativeSubdued: {
        background: {
            base: '#590810',
            highlight: '#6b0a13',
            press: '#9b0e1c',
            elevated: { base: '#6b0a13', highlight: '#6b0a13', press: '#9b0e1c' },
            tinted: { base: '#590810', highlight: '#590810', press: '#590810' },
        },
        text: {
            base: '#ffd2d7',
            subdued: '#ffd2d7',
            brightAccent: '#ffd2d7',
            negative: '#ffd2d7',
            warning: '#ffd2d7',
            positive: '#ffd2d7',
            announcement: '#ffd2d7',
        },
        essential: {
            base: '#ffd2d7',
            subdued: '#ffd2d7',
            brightAccent: '#ffd2d7',
            negative: '#ffd2d7',
            warning: '#ffd2d7',
            positive: '#ffd2d7',
            announcement: '#ffd2d7',
        },
        decorative: { base: '#ffd2d7', subdued: '#7b0b16' },
    },
    warning: {
        background: {
            base: '#ffa42b',
            highlight: '#ffb656',
            press: '#ee8800',
            elevated: { base: '#ffb656', highlight: '#ffb656', press: '#ee8800' },
            tinted: { base: '#ffa42b', highlight: '#ffa42b', press: '#ffa42b' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#f18900' },
    },
    warningSubdued: {
        background: {
            base: '#491e00',
            highlight: '#582400',
            press: '#833600',
            elevated: { base: '#582400', highlight: '#582400', press: '#833600' },
            tinted: { base: '#491e00', highlight: '#491e00', press: '#491e00' },
        },
        text: {
            base: '#ffd97e',
            subdued: '#ffd97e',
            brightAccent: '#ffd97e',
            negative: '#ffd97e',
            warning: '#ffd97e',
            positive: '#ffd97e',
            announcement: '#ffd97e',
        },
        essential: {
            base: '#ffd97e',
            subdued: '#ffd97e',
            brightAccent: '#ffd97e',
            negative: '#ffd97e',
            warning: '#ffd97e',
            positive: '#ffd97e',
            announcement: '#ffd97e',
        },
        decorative: { base: '#ffd97e', subdued: '#652a00' },
    },
    positive: {
        background: {
            base: '#1ed760',
            highlight: '#3be477',
            press: '#1abc54',
            elevated: { base: '#3be477', highlight: '#3be477', press: '#1abc54' },
            tinted: { base: '#1ed760', highlight: '#1ed760', press: '#1ed760' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#1abc54' },
    },
    positiveSubdued: {
        background: {
            base: '#073116',
            highlight: '#093c1b',
            press: '#0d5928',
            elevated: { base: '#093c1b', highlight: '#093c1b', press: '#0d5928' },
            tinted: { base: '#073116', highlight: '#073116', press: '#073116' },
        },
        text: {
            base: '#96f0b6',
            subdued: '#96f0b6',
            brightAccent: '#96f0b6',
            negative: '#96f0b6',
            warning: '#96f0b6',
            positive: '#96f0b6',
            announcement: '#96f0b6',
        },
        essential: {
            base: '#96f0b6',
            subdued: '#96f0b6',
            brightAccent: '#96f0b6',
            negative: '#96f0b6',
            warning: '#96f0b6',
            positive: '#96f0b6',
            announcement: '#96f0b6',
        },
        decorative: { base: '#96f0b6', subdued: '#0a4620' },
    },
    announcement: {
        background: {
            base: '#4cb3ff',
            highlight: '#69bfff',
            press: '#109aff',
            elevated: { base: '#69bfff', highlight: '#69bfff', press: '#109aff' },
            tinted: { base: '#4cb3ff', highlight: '#4cb3ff', press: '#4cb3ff' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#159cff' },
    },
    announcementSubdued: {
        background: {
            base: '#00285d',
            highlight: '#003171',
            press: '#0048a7',
            elevated: { base: '#003171', highlight: '#003171', press: '#0048a7' },
            tinted: { base: '#00285d', highlight: '#00285d', press: '#00285d' },
        },
        text: {
            base: '#c8e0fc',
            subdued: '#c8e0fc',
            brightAccent: '#c8e0fc',
            negative: '#c8e0fc',
            warning: '#c8e0fc',
            positive: '#c8e0fc',
            announcement: '#c8e0fc',
        },
        essential: {
            base: '#c8e0fc',
            subdued: '#c8e0fc',
            brightAccent: '#c8e0fc',
            negative: '#c8e0fc',
            warning: '#c8e0fc',
            positive: '#c8e0fc',
            announcement: '#c8e0fc',
        },
        decorative: { base: '#c8e0fc', subdued: '#003985' },
    },
    invertedDark: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#343434',
            elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
            tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
        },
        text: {
            base: '#ffffff',
            subdued: '#939393',
            brightAccent: '#1ed760',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#626262',
            brightAccent: '#1ed760',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    invertedLight: {
        background: {
            base: '#ffffff',
            highlight: '#f0f0f0',
            press: '#c7c7c7',
            elevated: { base: '#f0f0f0', highlight: '#f0f0f0', press: '#c7c7c7' },
            tinted: { base: '#ffffff', highlight: '#ffffff', press: '#ffffff' },
        },
        text: {
            base: '#000000',
            subdued: '#5a5a5a',
            brightAccent: '#127e38',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#8a8a8a',
            brightAccent: '#169f47',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    inverted: {
        background: {
            base: '#ffffff',
            highlight: '#f0f0f0',
            press: '#c7c7c7',
            elevated: { base: '#f0f0f0', highlight: '#f0f0f0', press: '#c7c7c7' },
            tinted: { base: '#ffffff', highlight: '#ffffff', press: '#ffffff' },
        },
        text: {
            base: '#000000',
            subdued: '#5a5a5a',
            brightAccent: '#127e38',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#8a8a8a',
            brightAccent: '#169f47',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    mutedAccent: {
        background: {
            base: '#1e1e1e',
            highlight: '#292929',
            press: '#101010',
            elevated: { base: '#292929', highlight: '#333333', press: '#242424' },
            tinted: {
                base: 'rgba(255, 255, 255, 0.09)',
                highlight: 'rgba(255, 255, 255, 0.13)',
                press: 'rgba(255, 255, 255, 0.21)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#bebebe',
            brightAccent: '#1ed760',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#858585',
            brightAccent: '#1ed760',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#353535' },
    },
    overMedia: {
        background: {
            base: 'rgba(0, 0, 0, 0.54)',
            highlight: 'rgba(0, 0, 0, 0.58)',
            press: 'rgba(0, 0, 0, 0.68)',
            elevated: {
                base: 'rgba(0, 0, 0, 0.58)',
                highlight: 'rgba(0, 0, 0, 0.58)',
                press: 'rgba(0, 0, 0, 0.68)',
            },
            tinted: {
                base: 'rgba(0, 0, 0, 0.54)',
                highlight: 'rgba(0, 0, 0, 0.54)',
                press: 'rgba(0, 0, 0, 0.54)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: 'rgba(255, 255, 255, 0.13)' },
    },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 * The SfA Light theme is used for Spotify For Authors, a product used to create, distribute, and monetize audiobooks.
 */
export var sfaLightTheme = {
    base: {
        background: {
            base: '#ffffff',
            highlight: '#f5f5f5',
            press: '#e2e2e2',
            elevated: { base: '#ffffff', highlight: '#f5f5f5', press: '#e7e7e7' },
            tinted: {
                base: 'rgba(0, 0, 0, 0.08)',
                highlight: 'rgba(0, 0, 0, 0.12)',
                press: 'rgba(0, 0, 0, 0.19)',
            },
        },
        text: {
            base: '#000000',
            subdued: '#656565',
            brightAccent: '#0c62c7',
            negative: '#c91123',
            warning: '#955500',
            positive: '#107434',
            announcement: '#0064c1',
        },
        essential: {
            base: '#000000',
            subdued: '#818181',
            brightAccent: '#1e7ff2',
            negative: '#e91429',
            warning: '#bf6d00',
            positive: '#159542',
            announcement: '#0074e0',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    brightAccent: {
        background: {
            base: '#89bcf8',
            highlight: '#9fc8f9',
            press: '#5fa4f6',
            elevated: { base: '#9fc8f9', highlight: '#9fc8f9', press: '#5fa4f6' },
            tinted: { base: '#89bcf8', highlight: '#89bcf8', press: '#89bcf8' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#60a5f6' },
    },
    negative: {
        background: {
            base: '#e91429',
            highlight: '#d81326',
            press: '#a60e1d',
            elevated: { base: '#d81326', highlight: '#d81326', press: '#a60e1d' },
            tinted: { base: '#e91429', highlight: '#e91429', press: '#e91429' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#ee3a4c' },
    },
    negativeSubdued: {
        background: {
            base: '#ffd2d7',
            highlight: '#ffe5e8',
            press: '#ffadb6',
            elevated: { base: '#ffe5e8', highlight: '#ffe5e8', press: '#ffadb6' },
            tinted: { base: '#ffd2d7', highlight: '#ffd2d7', press: '#ffd2d7' },
        },
        text: {
            base: '#590810',
            subdued: '#590810',
            brightAccent: '#590810',
            negative: '#590810',
            warning: '#590810',
            positive: '#590810',
            announcement: '#590810',
        },
        essential: {
            base: '#590810',
            subdued: '#590810',
            brightAccent: '#590810',
            negative: '#590810',
            warning: '#590810',
            positive: '#590810',
            announcement: '#590810',
        },
        decorative: { base: '#590810', subdued: '#ffb9c1' },
    },
    warning: {
        background: {
            base: '#ffa42b',
            highlight: '#ffb656',
            press: '#ee8800',
            elevated: { base: '#ffb656', highlight: '#ffb656', press: '#ee8800' },
            tinted: { base: '#ffa42b', highlight: '#ffa42b', press: '#ffa42b' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#f18900' },
    },
    warningSubdued: {
        background: {
            base: '#ffd97e',
            highlight: '#ffeab8',
            press: '#ffb504',
            elevated: { base: '#ffeab8', highlight: '#ffeab8', press: '#ffb504' },
            tinted: { base: '#ffd97e', highlight: '#ffd97e', press: '#ffd97e' },
        },
        text: {
            base: '#491e00',
            subdued: '#491e00',
            brightAccent: '#491e00',
            negative: '#491e00',
            warning: '#491e00',
            positive: '#491e00',
            announcement: '#491e00',
        },
        essential: {
            base: '#491e00',
            subdued: '#491e00',
            brightAccent: '#491e00',
            negative: '#491e00',
            warning: '#491e00',
            positive: '#491e00',
            announcement: '#491e00',
        },
        decorative: { base: '#491e00', subdued: '#ffc742' },
    },
    positive: {
        background: {
            base: '#1ed760',
            highlight: '#3be477',
            press: '#1abc54',
            elevated: { base: '#3be477', highlight: '#3be477', press: '#1abc54' },
            tinted: { base: '#1ed760', highlight: '#1ed760', press: '#1ed760' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#1abc54' },
    },
    positiveSubdued: {
        background: {
            base: '#96f0b6',
            highlight: '#c5f7d7',
            press: '#21df65',
            elevated: { base: '#c5f7d7', highlight: '#c5f7d7', press: '#21df65' },
            tinted: { base: '#96f0b6', highlight: '#96f0b6', press: '#96f0b6' },
        },
        text: {
            base: '#073116',
            subdued: '#073116',
            brightAccent: '#073116',
            negative: '#073116',
            warning: '#073116',
            positive: '#073116',
            announcement: '#073116',
        },
        essential: {
            base: '#073116',
            subdued: '#073116',
            brightAccent: '#073116',
            negative: '#073116',
            warning: '#073116',
            positive: '#073116',
            announcement: '#073116',
        },
        decorative: { base: '#073116', subdued: '#60e890' },
    },
    announcement: {
        background: {
            base: '#0074e0',
            highlight: '#006bcf',
            press: '#00529e',
            elevated: { base: '#006bcf', highlight: '#006bcf', press: '#00529e' },
            tinted: { base: '#0074e0', highlight: '#0074e0', press: '#0074e0' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#0386ff' },
    },
    announcementSubdued: {
        background: {
            base: '#b5e4ff',
            highlight: '#d5f0ff',
            press: '#75cdff',
            elevated: { base: '#d5f0ff', highlight: '#d5f0ff', press: '#75cdff' },
            tinted: { base: '#b5e4ff', highlight: '#b5e4ff', press: '#b5e4ff' },
        },
        text: {
            base: '#052a56',
            subdued: '#052a56',
            brightAccent: '#052a56',
            negative: '#052a56',
            warning: '#052a56',
            positive: '#052a56',
            announcement: '#052a56',
        },
        essential: {
            base: '#052a56',
            subdued: '#052a56',
            brightAccent: '#052a56',
            negative: '#052a56',
            warning: '#052a56',
            positive: '#052a56',
            announcement: '#052a56',
        },
        decorative: { base: '#052a56', subdued: '#85d3ff' },
    },
    invertedDark: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#343434',
            elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
            tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
        },
        text: {
            base: '#ffffff',
            subdued: '#939393',
            brightAccent: '#89bcf8',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#626262',
            brightAccent: '#89bcf8',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    invertedLight: {
        background: {
            base: '#ffffff',
            highlight: '#f0f0f0',
            press: '#c7c7c7',
            elevated: { base: '#f0f0f0', highlight: '#f0f0f0', press: '#c7c7c7' },
            tinted: { base: '#ffffff', highlight: '#ffffff', press: '#ffffff' },
        },
        text: {
            base: '#000000',
            subdued: '#5a5a5a',
            brightAccent: '#0d6ad8',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#8a8a8a',
            brightAccent: '#328bf3',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    inverted: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#343434',
            elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
            tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
        },
        text: {
            base: '#ffffff',
            subdued: '#939393',
            brightAccent: '#89bcf8',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#626262',
            brightAccent: '#89bcf8',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    mutedAccent: {
        background: {
            base: '#121212',
            highlight: '#1b1b1b',
            press: '#040404',
            elevated: { base: '#1b1b1b', highlight: '#232323', press: '#171717' },
            tinted: {
                base: 'rgba(255, 255, 255, 0.07)',
                highlight: 'rgba(255, 255, 255, 0.1)',
                press: 'rgba(255, 255, 255, 0.15)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#a7a7a7',
            brightAccent: '#89bcf8',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#727272',
            brightAccent: '#89bcf8',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#292929' },
    },
    overMedia: {
        background: {
            base: 'rgba(0, 0, 0, 0.54)',
            highlight: 'rgba(0, 0, 0, 0.58)',
            press: 'rgba(0, 0, 0, 0.68)',
            elevated: {
                base: 'rgba(0, 0, 0, 0.58)',
                highlight: 'rgba(0, 0, 0, 0.58)',
                press: 'rgba(0, 0, 0, 0.68)',
            },
            tinted: {
                base: 'rgba(0, 0, 0, 0.54)',
                highlight: 'rgba(0, 0, 0, 0.54)',
                press: 'rgba(0, 0, 0, 0.54)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: 'rgba(255, 255, 255, 0.13)' },
    },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 * The SfA Dark theme is used for Spotify For Authors, a product used to create, distribute, and monetize audiobooks.
 */
export var sfaDarkTheme = {
    base: {
        background: {
            base: '#121212',
            highlight: '#1f1f1f',
            press: '#000000',
            elevated: { base: '#1f1f1f', highlight: '#2a2a2a', press: '#191919' },
            tinted: {
                base: 'rgba(255, 255, 255, 0.1)',
                highlight: 'rgba(255, 255, 255, 0.14)',
                press: 'rgba(255, 255, 255, 0.21)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#b3b3b3',
            brightAccent: '#89bcf8',
            negative: '#f3727f',
            warning: '#ffa42b',
            positive: '#1ed760',
            announcement: '#4cb3ff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#7c7c7c',
            brightAccent: '#89bcf8',
            negative: '#ed2c3f',
            warning: '#ffa42b',
            positive: '#1ed760',
            announcement: '#4cb3ff',
        },
        decorative: { base: '#ffffff', subdued: '#292929' },
    },
    brightAccent: {
        background: {
            base: '#89bcf8',
            highlight: '#9fc8f9',
            press: '#5fa4f6',
            elevated: { base: '#9fc8f9', highlight: '#9fc8f9', press: '#5fa4f6' },
            tinted: { base: '#89bcf8', highlight: '#89bcf8', press: '#89bcf8' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#60a5f6' },
    },
    negative: {
        background: {
            base: '#e91429',
            highlight: '#d81326',
            press: '#a60e1d',
            elevated: { base: '#d81326', highlight: '#d81326', press: '#a60e1d' },
            tinted: { base: '#e91429', highlight: '#e91429', press: '#e91429' },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#ee3a4c' },
    },
    negativeSubdued: {
        background: {
            base: '#590810',
            highlight: '#6b0a13',
            press: '#9b0e1c',
            elevated: { base: '#6b0a13', highlight: '#6b0a13', press: '#9b0e1c' },
            tinted: { base: '#590810', highlight: '#590810', press: '#590810' },
        },
        text: {
            base: '#ffd2d7',
            subdued: '#ffd2d7',
            brightAccent: '#ffd2d7',
            negative: '#ffd2d7',
            warning: '#ffd2d7',
            positive: '#ffd2d7',
            announcement: '#ffd2d7',
        },
        essential: {
            base: '#ffd2d7',
            subdued: '#ffd2d7',
            brightAccent: '#ffd2d7',
            negative: '#ffd2d7',
            warning: '#ffd2d7',
            positive: '#ffd2d7',
            announcement: '#ffd2d7',
        },
        decorative: { base: '#ffd2d7', subdued: '#7b0b16' },
    },
    warning: {
        background: {
            base: '#ffa42b',
            highlight: '#ffb656',
            press: '#ee8800',
            elevated: { base: '#ffb656', highlight: '#ffb656', press: '#ee8800' },
            tinted: { base: '#ffa42b', highlight: '#ffa42b', press: '#ffa42b' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#f18900' },
    },
    warningSubdued: {
        background: {
            base: '#491e00',
            highlight: '#582400',
            press: '#833600',
            elevated: { base: '#582400', highlight: '#582400', press: '#833600' },
            tinted: { base: '#491e00', highlight: '#491e00', press: '#491e00' },
        },
        text: {
            base: '#ffd97e',
            subdued: '#ffd97e',
            brightAccent: '#ffd97e',
            negative: '#ffd97e',
            warning: '#ffd97e',
            positive: '#ffd97e',
            announcement: '#ffd97e',
        },
        essential: {
            base: '#ffd97e',
            subdued: '#ffd97e',
            brightAccent: '#ffd97e',
            negative: '#ffd97e',
            warning: '#ffd97e',
            positive: '#ffd97e',
            announcement: '#ffd97e',
        },
        decorative: { base: '#ffd97e', subdued: '#652a00' },
    },
    positive: {
        background: {
            base: '#1ed760',
            highlight: '#3be477',
            press: '#1abc54',
            elevated: { base: '#3be477', highlight: '#3be477', press: '#1abc54' },
            tinted: { base: '#1ed760', highlight: '#1ed760', press: '#1ed760' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#1abc54' },
    },
    positiveSubdued: {
        background: {
            base: '#073116',
            highlight: '#093c1b',
            press: '#0d5928',
            elevated: { base: '#093c1b', highlight: '#093c1b', press: '#0d5928' },
            tinted: { base: '#073116', highlight: '#073116', press: '#073116' },
        },
        text: {
            base: '#96f0b6',
            subdued: '#96f0b6',
            brightAccent: '#96f0b6',
            negative: '#96f0b6',
            warning: '#96f0b6',
            positive: '#96f0b6',
            announcement: '#96f0b6',
        },
        essential: {
            base: '#96f0b6',
            subdued: '#96f0b6',
            brightAccent: '#96f0b6',
            negative: '#96f0b6',
            warning: '#96f0b6',
            positive: '#96f0b6',
            announcement: '#96f0b6',
        },
        decorative: { base: '#96f0b6', subdued: '#0a4620' },
    },
    announcement: {
        background: {
            base: '#4cb3ff',
            highlight: '#69bfff',
            press: '#109aff',
            elevated: { base: '#69bfff', highlight: '#69bfff', press: '#109aff' },
            tinted: { base: '#4cb3ff', highlight: '#4cb3ff', press: '#4cb3ff' },
        },
        text: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#000000',
            brightAccent: '#000000',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#159cff' },
    },
    announcementSubdued: {
        background: {
            base: '#00285d',
            highlight: '#003171',
            press: '#0048a7',
            elevated: { base: '#003171', highlight: '#003171', press: '#0048a7' },
            tinted: { base: '#00285d', highlight: '#00285d', press: '#00285d' },
        },
        text: {
            base: '#c8e0fc',
            subdued: '#c8e0fc',
            brightAccent: '#c8e0fc',
            negative: '#c8e0fc',
            warning: '#c8e0fc',
            positive: '#c8e0fc',
            announcement: '#c8e0fc',
        },
        essential: {
            base: '#c8e0fc',
            subdued: '#c8e0fc',
            brightAccent: '#c8e0fc',
            negative: '#c8e0fc',
            warning: '#c8e0fc',
            positive: '#c8e0fc',
            announcement: '#c8e0fc',
        },
        decorative: { base: '#c8e0fc', subdued: '#003985' },
    },
    invertedDark: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#343434',
            elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
            tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
        },
        text: {
            base: '#ffffff',
            subdued: '#939393',
            brightAccent: '#89bcf8',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#626262',
            brightAccent: '#89bcf8',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    invertedLight: {
        background: {
            base: '#ffffff',
            highlight: '#f0f0f0',
            press: '#c7c7c7',
            elevated: { base: '#f0f0f0', highlight: '#f0f0f0', press: '#c7c7c7' },
            tinted: { base: '#ffffff', highlight: '#ffffff', press: '#ffffff' },
        },
        text: {
            base: '#000000',
            subdued: '#5a5a5a',
            brightAccent: '#0d6ad8',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#8a8a8a',
            brightAccent: '#328bf3',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    inverted: {
        background: {
            base: '#ffffff',
            highlight: '#f0f0f0',
            press: '#c7c7c7',
            elevated: { base: '#f0f0f0', highlight: '#f0f0f0', press: '#c7c7c7' },
            tinted: { base: '#ffffff', highlight: '#ffffff', press: '#ffffff' },
        },
        text: {
            base: '#000000',
            subdued: '#5a5a5a',
            brightAccent: '#0d6ad8',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        essential: {
            base: '#000000',
            subdued: '#8a8a8a',
            brightAccent: '#328bf3',
            negative: '#000000',
            warning: '#000000',
            positive: '#000000',
            announcement: '#000000',
        },
        decorative: { base: '#000000', subdued: '#dedede' },
    },
    mutedAccent: {
        background: {
            base: '#000000',
            highlight: '#141414',
            press: '#2b2b2b',
            elevated: { base: '#141414', highlight: '#212121', press: '#0b0b0b' },
            tinted: {
                base: 'rgba(255, 255, 255, 0.13)',
                highlight: 'rgba(255, 255, 255, 0.17)',
                press: 'rgba(255, 255, 255, 0.24)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#a9a9a9',
            brightAccent: '#89bcf8',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#747474',
            brightAccent: '#89bcf8',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: '#1f1f1f' },
    },
    overMedia: {
        background: {
            base: 'rgba(0, 0, 0, 0.54)',
            highlight: 'rgba(0, 0, 0, 0.58)',
            press: 'rgba(0, 0, 0, 0.68)',
            elevated: {
                base: 'rgba(0, 0, 0, 0.58)',
                highlight: 'rgba(0, 0, 0, 0.58)',
                press: 'rgba(0, 0, 0, 0.68)',
            },
            tinted: {
                base: 'rgba(0, 0, 0, 0.54)',
                highlight: 'rgba(0, 0, 0, 0.54)',
                press: 'rgba(0, 0, 0, 0.54)',
            },
        },
        text: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        essential: {
            base: '#ffffff',
            subdued: '#ffffff',
            brightAccent: '#ffffff',
            negative: '#ffffff',
            warning: '#ffffff',
            positive: '#ffffff',
            announcement: '#ffffff',
        },
        decorative: { base: '#ffffff', subdued: 'rgba(255, 255, 255, 0.13)' },
    },
};
